webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/*!******************************************!*\
  !*** ./client/components/Title/index.js ***!
  \******************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_kebabcase__ = __webpack_require__(/*! lodash.kebabcase */ 190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_kebabcase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_kebabcase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mixins_className__ = __webpack_require__(/*! mixins/className */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_scss__ = __webpack_require__(/*! ./style.scss */ 191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_scss__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Title',
  props: {
    level: {
      type: Number,
      default: 1
    },
    modifiers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    richText: {
      type: String
    },
    id: {
      type: String
    }
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1_mixins_className__["a" /* default */]],
  computed: {
    computedModifiers: function computedModifiers() {
      // Each modifier has to be registered within props and pushed to the modifier array
      return ['h' + this.level].concat(_toConsumableArray(this.modifiers));
    },
    idAttr: function idAttr() {
      return this.id ? __WEBPACK_IMPORTED_MODULE_0_lodash_kebabcase___default()(this.id) : '';
    }
  },
  render: function render(h) {
    var Tag = 'h' + this.level;
    var className = this.className(this.$options.name, this.computedModifiers);
    if (this.richText) {
      return (
        // Use richText prop to deal with HTML elements (like <br />)
        h(Tag, { 'class': className, attrs: { id: this.idAttr },
          domProps: {
            'innerHTML': this.richText
          }
        })
      );
    } else {
      return h(
        Tag,
        { 'class': className, attrs: { id: this.idAttr }
        },
        [this.$slots.default]
      );
    }
  }
});

/***/ }),
/* 5 */,
/* 6 */
/*!***********************************************!*\
  !*** ./client/util/verifyLeadingSlashLang.js ***!
  \***********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = verifyLeadingSlashLang;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_util_verifyLeadingSlash__ = __webpack_require__(/*! util/verifyLeadingSlash */ 24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_util_verifyLeadingLang__ = __webpack_require__(/*! util/verifyLeadingLang */ 193);



function verifyLeadingSlashLang(string, lang) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_util_verifyLeadingLang__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0_util_verifyLeadingSlash__["a" /* default */])(string), lang);
}

/***/ }),
/* 7 */
/*!*********************************************!*\
  !*** ./client/components/RichText/index.js ***!
  \*********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_scss__ = __webpack_require__(/*! ./style.scss */ 195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_scss__);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'RichText',
  props: ['content'],
  render: function render(h) {
    return h('div', {
      domProps: {
        'innerHTML': this.content
      },
      'class': 'RichText' });
  }
});

/***/ }),
/* 8 */
/*!***************************************!*\
  !*** ./client/util/getPathFromUrl.js ***!
  \***************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getPathFromUrl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_util_verifyLeadingSlash__ = __webpack_require__(/*! util/verifyLeadingSlash */ 24);


function getPathFromUrl(string) {
  var regex = /(http[s]?:\/\/)?([^\/\s]+\/)(.*)/;
  var str = string;
  var subst = '$3';
  var result = str.replace(regex, subst);
  return Object(__WEBPACK_IMPORTED_MODULE_0_util_verifyLeadingSlash__["a" /* default */])(result);
}

/***/ }),
/* 9 */,
/* 10 */
/*!********************************!*\
  !*** ./client/common/index.js ***!
  \********************************/
/*! exports provided: generateMetaTitle, generateMetaInfo, generateMetaImage */
/*! exports used: generateMetaInfo */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__generateMetaInfo__ = __webpack_require__(/*! ./generateMetaInfo */ 188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__generateMetaTitle__ = __webpack_require__(/*! ./generateMetaTitle */ 21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__generateMetaImage__ = __webpack_require__(/*! ./generateMetaImage */ 22);
/* unused harmony reexport generateMetaTitle */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__generateMetaInfo__["a"]; });
/* unused harmony reexport generateMetaImage */






/***/ }),
/* 11 */,
/* 12 */
/*!*************************************!*\
  !*** ./client/views/Error/index.js ***!
  \*************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(/*! ../../common */ 10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Title__ = __webpack_require__(/*! components/Title */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Breadcrumbs__ = __webpack_require__(/*! components/Breadcrumbs */ 23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_FlexContent__ = __webpack_require__(/*! components/FlexContent */ 14);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ErrorView',
  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["d" /* mapState */])(['error']), Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['lang', 'getStringTranslation', 'loading', 'getPageBySlug', 'options']), {
    page: function page() {
      return this.getPageBySlug('error');
    },
    pageTitle: function pageTitle() {
      return this.page.page_title_override ? this.page.page_title_override : this.page.title.rendered;
    }
  }),
  methods: {
    getTranslation: function getTranslation(translationTitle) {
      return this.getStringTranslation(translationTitle);
    }
  },
  metaInfo: function metaInfo() {
    // don't do alternate and canonical etc...
    var page = this.page;
    var metaInfo = page ? Object(__WEBPACK_IMPORTED_MODULE_1__common__["a" /* generateMetaInfo */])(this.options, this.page, { error: this.error.status }) : { meta: [] };
    return metaInfo;
  },
  render: function render(h) {
    return h(
      'div',
      { 'class': 'page' },
      [h(__WEBPACK_IMPORTED_MODULE_3_components_Breadcrumbs__["a" /* default */], {
        attrs: { page: this.page }
      }), h(
        __WEBPACK_IMPORTED_MODULE_2_components_Title__["a" /* default */],
        {
          attrs: { level: 1 }
        },
        [this.error.status && this.error.status !== 404 ? this.getTranslation('error_occured') + ' (' + this.error.status + ')' : this.getTranslation('error_404')]
      ), this.page.c_flex_content && this.page.c_flex_content.length ? h(__WEBPACK_IMPORTED_MODULE_4_components_FlexContent__["a" /* default */], {
        attrs: { componentData: this.page.c_flex_content }
      }) : null]
    );
  }
});

/***/ }),
/* 13 */
/*!************************************!*\
  !*** ./client/mixins/className.js ***!
  \************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// generate BEM like class names from modifiers
var classNameMixin = {
  methods: {
    className: function className(componentName, modifiers, stateClasses) {
      var mods = modifiers.reduce(function (str, modifier) {
        return str + (' ' + componentName + '--' + modifier);
      }, '');

      var stateC = stateClasses && Array.isArray(stateClasses) && stateClasses.length ? ' ' + stateClasses.join(' ') : stateClasses || '';

      return componentName + mods + stateC;
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (classNameMixin);

/***/ }),
/* 14 */
/*!************************************************!*\
  !*** ./client/components/FlexContent/index.js ***!
  \************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_scss__ = __webpack_require__(/*! ./style.scss */ 194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_RichText__ = __webpack_require__(/*! components/RichText */ 7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Images__ = __webpack_require__(/*! components/Images */ 196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_TeaserGrid__ = __webpack_require__(/*! components/TeaserGrid */ 200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Accordion__ = __webpack_require__(/*! components/Accordion */ 25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_LinkGroup__ = __webpack_require__(/*! components/LinkGroup */ 15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Form_Form__ = __webpack_require__(/*! components/Form/Form */ 27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Form_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_Form_Form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_ContentList__ = __webpack_require__(/*! components/ContentList */ 241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_DownloadsList__ = __webpack_require__(/*! components/DownloadsList */ 243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_VideoGrid__ = __webpack_require__(/*! components/VideoGrid */ 245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_ContactSection__ = __webpack_require__(/*! components/ContactSection */ 249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_GalleryWrapper__ = __webpack_require__(/*! components/GalleryWrapper */ 251);














/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FlexContent',
  props: ['componentData'],
  render: function render(h) {
    var componentData = this.componentData;

    return h(
      'div',
      { 'class': 'FlexContent' },
      [componentData.map(function (c) {
        return renderLayout(h, c);
      })]
    );
  }
});

function renderLayout(h, component) {
  var layoutType = component.acf_fc_layout;
  if (layoutType === 'text') {
    return h(
      'div',
      { 'class': 'FlexContent__item FlexContent__item--' + layoutType },
      [h(__WEBPACK_IMPORTED_MODULE_1_components_RichText__["a" /* default */], {
        attrs: { content: component.rich_text }
      })]
    );
  } else if (layoutType === 'images') {
    return h(
      'div',
      { 'class': 'FlexContent__item FlexContent__item--' + layoutType },
      [h(__WEBPACK_IMPORTED_MODULE_2_components_Images__["a" /* default */], {
        attrs: { componentData: component.images }
      })]
    );
  } else if (layoutType === 'teaser_grid' || layoutType === 'image_teaser_grid') {
    return h(
      'div',
      { 'class': 'FlexContent__item FlexContent__item--' + layoutType },
      [h(__WEBPACK_IMPORTED_MODULE_3_components_TeaserGrid__["a" /* default */], {
        attrs: { componentData: component.teasers, addLinks: component.add_links }
      })]
    );
  } else if (layoutType === 'accordion') {
    return h(
      'div',
      { 'class': 'FlexContent__item FlexContent__item--' + layoutType },
      [h(__WEBPACK_IMPORTED_MODULE_4_components_Accordion__["a" /* default */], {
        attrs: { sections: component.accordion_items }
      })]
    );
  } else if (layoutType === 'link_group') {
    return h(
      'div',
      { 'class': 'FlexContent__item FlexContent__item--' + layoutType },
      [h(__WEBPACK_IMPORTED_MODULE_5_components_LinkGroup__["a" /* default */], {
        attrs: { componentData: component.links }
      })]
    );
  } else if (layoutType === 'form') {
    return h(
      'div',
      { 'class': 'FlexContent__item FlexContent__item--' + layoutType },
      [h(__WEBPACK_IMPORTED_MODULE_6_components_Form_Form___default.a, {
        attrs: { buttonText: component.button_text,
          formEndpoint: component.form_endpoint,
          formFields: component.form_fields,
          showConfirmation: component.show_confirmation,
          confirmationTitle: component.confirmation_title,
          confirmationText: component.confirmation_text,
          gdpr: component.gdpr,
          showNewsletterSignup: component.show_newsletter_signup,
          showFeedbackForm: component.show_feedback_form,
          feedbackForm: component.feedback_form
        }
      })]
    );
  } else if (layoutType === 'content_list') {
    return h(
      'div',
      { 'class': 'FlexContent__item FlexContent__item--' + layoutType },
      [h(__WEBPACK_IMPORTED_MODULE_7_components_ContentList__["a" /* default */], {
        attrs: { componentData: component.list_sections }
      })]
    );
  } else if (layoutType === 'downloads_list') {
    return h(
      'div',
      { 'class': 'FlexContent__item FlexContent__item--' + layoutType },
      [h(__WEBPACK_IMPORTED_MODULE_8_components_DownloadsList__["a" /* default */], {
        attrs: { componentData: component.downloads_section }
      })]
    );
  } else if (layoutType === 'video_grid') {
    return h(
      'div',
      { 'class': 'FlexContent__item FlexContent__item--' + layoutType },
      [h(__WEBPACK_IMPORTED_MODULE_9_components_VideoGrid__["a" /* default */], {
        attrs: { componentData: component.video_grid_items }
      })]
    );
  } else if (layoutType === 'contact_section') {
    return h(
      'div',
      { 'class': 'FlexContent__item FlexContent__item--' + layoutType },
      [h(__WEBPACK_IMPORTED_MODULE_10_components_ContactSection__["a" /* default */], {
        attrs: { title: component.contact_section_title, items: component.contact_items }
      })]
    );
  } else if (layoutType === 'image_gallery') {
    return h(
      'div',
      { 'class': 'FlexContent__item FlexContent__item--' + layoutType },
      [h(__WEBPACK_IMPORTED_MODULE_11_components_GalleryWrapper__["a" /* default */], {
        attrs: { componentData: component.images }
      })]
    );
  }
}

/***/ }),
/* 15 */
/*!**********************************************!*\
  !*** ./client/components/LinkGroup/index.js ***!
  \**********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_scss__ = __webpack_require__(/*! ./style.scss */ 208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Link__ = __webpack_require__(/*! components/Link */ 26);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LinkGroup',
  props: ['componentData'],
  render: function render(h) {
    var componentData = this.componentData;

    return h(
      'div',
      { 'class': 'LinkGroup' },
      [componentData.map(function (i) {
        return h(__WEBPACK_IMPORTED_MODULE_1_components_Link__["a" /* default */], {
          attrs: { title: i.title, externalLink: i.external_link, externalLinkUrl: i.external_link_url, internalLink: i.internal_link }
        });
      })]
    );
  }
});

/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
/*!********************************************!*\
  !*** ./client/common/generateMetaTitle.js ***!
  \********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = generateMetaTitle;
function generateMetaTitle(siteOptions, page) {
  // console.log('siteOptions: ', siteOptions)
  // console.log('page: ', page)

  if (siteOptions.og_site_name) {
    var title = {
      pageTitle: siteOptions.og_site_name,
      ogTitle: siteOptions.og_site_name

      // If we have a title object in our page data, use it
    };page.title ? title = {
      pageTitle: page.title.rendered || page.title,
      ogTitle: page.title.rendered || page.title
    } : null;

    // Check for page title override
    page.page_title_override ? title = {
      pageTitle: page.page_title_override,
      ogTitle: page.page_title_override
    } : null;

    // Check for SEO title
    if (page.seo_enabled) {
      // console.log('SEO enabled')
      page.seo_title ? title = {
        pageTitle: page.seo_title,
        ogTitle: page.seo_title
      } : null;
    }

    // Check for OG title
    if (page.og_enabled) {
      // console.log('OG enabled')
      page.og_title ? title.ogTitle = page.og_title : null;
    }

    // console.log('title', title)
    return title;
  }
}

/***/ }),
/* 22 */
/*!********************************************!*\
  !*** ./client/common/generateMetaImage.js ***!
  \********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = generateMetaImage;
function generateMetaImage(siteOptions, page) {
  if (siteOptions.default_og_image) {
    var image = siteOptions.default_og_image.sizes['friwi_social-share-large'];

    if (page.og_enabled) {
      page.og_image ? image = page.og_image.sizes['friwi_social-share-large'] : null;
    }

    return image;
  }
}

/***/ }),
/* 23 */
/*!************************************************!*\
  !*** ./client/components/Breadcrumbs/index.js ***!
  \************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_scss__ = __webpack_require__(/*! ./style.scss */ 192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(/*! vuex */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_verifyLeadingSlashLang__ = __webpack_require__(/*! util/verifyLeadingSlashLang */ 6);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Breadcrumbs',
  props: ['page'],
  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getParentsById', 'getStringTranslation', 'loaded', 'lang']), {
    breadcrumbItems: function breadcrumbItems() {
      return this.getParentsById(this.page.id);
    }
  }),
  methods: {
    getTranslation: function getTranslation(translationTitle) {
      return this.getStringTranslation(translationTitle);
    }
  },
  render: function render(h) {
    /* TODO: This should be an array of item with links */
    var loaded = this.loaded,
        breadcrumbItems = this.breadcrumbItems,
        lang = this.lang;

    return h(
      'nav',
      { 'class': 'Breadcrumbs' },
      [loaded ? h(
        'ul',
        { 'class': 'Breadcrumbs__list' },
        [h(
          'li',
          { 'class': 'Breadcrumbs__list-item' },
          [h(
            'router-link',
            {
              attrs: { to: lang === 'en' ? '/en' : '/' },
              'class': 'Breadcrumbs__list-item-link' },
            [this.getTranslation('home')]
          )]
        ), breadcrumbItems.map(function (i) {
          return h(
            'li',
            { 'class': 'Breadcrumbs__list-item' },
            [h(
              'router-link',
              {
                attrs: { to: Object(__WEBPACK_IMPORTED_MODULE_2_util_verifyLeadingSlashLang__["a" /* default */])(i.uri, lang) },
                'class': 'Breadcrumbs__list-item-link' },
              [i.title.rendered]
            )]
          );
        })]
      ) : 'Loading…']
    );
  }
});

/***/ }),
/* 24 */
/*!*******************************************!*\
  !*** ./client/util/verifyLeadingSlash.js ***!
  \*******************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = verifyLeadingSlash;
function verifyLeadingSlash(string) {
  return string.startsWith('/') ? string : '/' + string;
}

/***/ }),
/* 25 */
/*!**********************************************!*\
  !*** ./client/components/Accordion/index.js ***!
  \**********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mixins_className__ = __webpack_require__(/*! mixins/className */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_AccordionSection__ = __webpack_require__(/*! components/AccordionSection */ 204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_scss__ = __webpack_require__(/*! ./style.scss */ 207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_scss__);
// Inspired by https://www.w3.org/TR/wai-aria-practices/examples/accordion/accordion.html






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Accordion',
  props: {
    sections: {
      type: Array,
      default: null
    },
    isNavigation: {
      type: Boolean,
      default: false
    },
    modifiers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    allowToggle: {
      type: Boolean,
      default: false
    },
    allowMultiple: {
      type: Boolean,
      default: false
    }
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_mixins_className__["a" /* default */]],
  render: function render(h) {
    var sections = this.sections,
        modifiers = this.modifiers,
        isNavigation = this.isNavigation;

    return sections ? h(
      'dl',
      { 'class': this.className(this.$options.name, modifiers), attrs: { role: 'presentation' }
      },
      [sections.map(function (s) {
        return h(__WEBPACK_IMPORTED_MODULE_1_components_AccordionSection__["a" /* default */], {
          attrs: { isNavigation: isNavigation, modifiers: modifiers, section: s }
        });
      })]
    ) : null;
  }
});

/***/ }),
/* 26 */
/*!*****************************************!*\
  !*** ./client/components/Link/index.js ***!
  \*****************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_scss__ = __webpack_require__(/*! ./style.scss */ 209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(/*! vuex */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_getPathFromUrl__ = __webpack_require__(/*! util/getPathFromUrl */ 8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util_verifyLeadingSlashLang__ = __webpack_require__(/*! util/verifyLeadingSlashLang */ 6);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Link',
  props: ['title', 'externalLink', 'externalLinkUrl', 'internalLink', 'internalLinkAbsolute', 'button'],
  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['lang']), {
    internalLinkPath: function internalLinkPath() {
      return this.internalLink ? Object(__WEBPACK_IMPORTED_MODULE_2_util_getPathFromUrl__["a" /* default */])(this.internalLink) : '';
    },
    aboluteLink: function aboluteLink() {
      return this.internalLinkAbsolute ? Object(__WEBPACK_IMPORTED_MODULE_2_util_getPathFromUrl__["a" /* default */])(this.internalLinkAbsolute) : '';
    }
  }),
  methods: {
    getLinkMarkup: function getLinkMarkup() {
      var h = this.$createElement;
      var title = this.title,
          externalLink = this.externalLink,
          externalLinkUrl = this.externalLinkUrl,
          internalLinkPath = this.internalLinkPath,
          internalLinkAbsolute = this.internalLinkAbsolute,
          aboluteLink = this.aboluteLink,
          button = this.button,
          lang = this.lang;

      var markup = void 0;
      if (button) {
        markup = h(
          'button',
          { 'class': 'Link__inner' },
          [title]
        );
      } else if (externalLink) {
        markup = h(
          'a',
          { 'class': 'Link__inner', attrs: { href: externalLinkUrl, target: '_blank', rel: 'noopener' }
          },
          [title]
        );
      } else if (internalLinkAbsolute) {
        markup = h(
          'router-link',
          { 'class': 'Link__inner', attrs: { to: aboluteLink }
          },
          [title]
        );
      } else {
        markup = h(
          'router-link',
          { 'class': 'Link__inner', attrs: { to: Object(__WEBPACK_IMPORTED_MODULE_3_util_verifyLeadingSlashLang__["a" /* default */])(internalLinkPath, lang) }
          },
          [title]
        );
      }
      return markup;
    }
  },
  render: function render(h) {
    return h(
      'div',
      { 'class': 'Link' },
      [this.getLinkMarkup()]
    );
  }
});

/***/ }),
/* 27 */
/*!*****************************************!*\
  !*** ./client/components/Form/Form.vue ***!
  \*****************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-685889aa","scoped":false,"hasInlineConfig":false}!sass-loader?sourceMap!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Form.vue */ 210)
}
var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 28)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Form.vue */ 212),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-685889aa","hasScoped":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Form.vue */ 240),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */
/*!*****************************************!*\
  !*** ./client/components/Logo/index.js ***!
  \*****************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_scss__ = __webpack_require__(/*! ./style.scss */ 257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(/*! vuex */ 1);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Logo',
  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['lang'])),
  render: function render(h) {
    var lang = this.lang;

    return h(
      'router-link',
      { 'class': 'Logo', attrs: { to: lang === 'en' ? '/en' : '/', exact: true }
      },
      [h('img', { 'class': 'Logo__img', attrs: { src: '/imgs/logo.svg', alt: 'Logo' }
      })]
    );
  }
});

/***/ }),
/* 172 */
/*!**********************************************!*\
  !*** ./client/components/HeroImage/index.js ***!
  \**********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_scss__ = __webpack_require__(/*! ./style.scss */ 276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_scss__);
var _name$props$props$ren;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = (_name$props$props$ren = {
  name: 'HeroImage',
  props: ['imageUrl']
}, _defineProperty(_name$props$props$ren, 'props', {
  imageUrl: {
    type: String
  }
}), _defineProperty(_name$props$props$ren, 'render', function render(h) {
  var imageUrl = this.imageUrl,
      hasTeaser = this.hasTeaser;

  return h(
    'div',
    { 'class': 'HeroImage' },
    [h('div', {
      'class': 'HeroImage__img',
      style: 'background-image: url(\'' + imageUrl + '\')'
    })]
  );
}), _name$props$props$ren);

/***/ }),
/* 173 */
/*!*************************!*\
  !*** ./client/index.js ***!
  \*************************/
/*! no exports provided */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__promise_polyfill__ = __webpack_require__(/*! ./promise-polyfill */ 174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(/*! ./app */ 177);


// Enable progressive web app support (with offline-plugin)
// if (process.env.NODE_ENV === 'production') {
//   require('./pwa')
// }

__WEBPACK_IMPORTED_MODULE_1__app__["a" /* app */].$mount('#app');

/***/ }),
/* 174 */
/*!************************************!*\
  !*** ./client/promise-polyfill.js ***!
  \************************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_promise_polyfill__ = __webpack_require__(/*! promise-polyfill */ 175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_promise_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_promise_polyfill__);


window.Promise = window.Promise || __WEBPACK_IMPORTED_MODULE_0_promise_polyfill___default.a;

/***/ }),
/* 175 */,
/* 176 */,
/* 177 */
/*!***********************!*\
  !*** ./client/app.js ***!
  \***********************/
/*! exports provided: app, router, store */
/*! exports used: app */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return app; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_shim__ = __webpack_require__(/*! es6-shim */ 178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_shim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_shim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(/*! vue */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_router_sync__ = __webpack_require__(/*! vuex-router-sync */ 179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_App__ = __webpack_require__(/*! ./views/App */ 180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(/*! ./router */ 272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(/*! ./store */ 283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_gtag__ = __webpack_require__(/*! vue-gtag */ 20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_lazyload__ = __webpack_require__(/*! vue-lazyload */ 293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vee_validate__ = __webpack_require__(/*! vee-validate */ 294);
/* unused harmony reexport router */
/* unused harmony reexport store */









// import VueTouch from 'vue-touch'
// import Log from './plugins/log'

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_lazyload__["a" /* default */]);
// Vue.use(VueTouch, { name: 'v-touch' })
// Vue.use(Log)


var veeValidateConfig = {
  errorBagName: 'veeValidateErrors', // change if property conflicts.
  fieldsBagName: 'veeValidateFields',
  delay: 100,
  locale: 'de',
  dictionary: null,
  strict: true,
  classes: true,
  classNames: {
    touched: 'is-touched', // the control has been blurred
    untouched: 'is-untouched', // the control hasn't been blurred
    valid: 'is-valid', // model is valid
    invalid: 'is-invalid', // model is invalid
    pristine: 'is-pristine', // control has not been interacted with
    dirty: 'is-dirty' // control has been interacted with
  },
  events: 'input|blur',
  inject: true,
  validity: true,
  aria: true
};
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vee_validate__["a" /* default */], veeValidateConfig);

Object(__WEBPACK_IMPORTED_MODULE_2_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_gtag__["b" /* default */], {
  config: {
    id: 'G-07MSX6KN0W',
    params: {
      anonymize_ip: true
    }
  },
  bootstrap: false
}, __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */]);

var app = new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */](Object.assign({
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */]
}, __WEBPACK_IMPORTED_MODULE_3__views_App__["a" /* default */]));



/***/ }),
/* 178 */,
/* 179 */,
/* 180 */
/*!***********************************!*\
  !*** ./client/views/App/index.js ***!
  \***********************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styles_main__ = __webpack_require__(/*! styles/main */ 181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styles_main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_styles_main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Layout__ = __webpack_require__(/*! components/Layout */ 182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_views_Error__ = __webpack_require__(/*! views/Error */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Header__ = __webpack_require__(/*! components/Header */ 255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Footer__ = __webpack_require__(/*! components/Footer */ 266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_HomeTeaser__ = __webpack_require__(/*! components/HomeTeaser */ 268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(/*! vuex */ 1);











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'App',
  metaInfo: {
    title: 'frischer wind',
    titleTemplate: '%s | frischer wind'
  },
  data: function data() {
    return {
      UABrowser: ''
    };
  },
  created: function created() {
    var urlLangDetected = this.$route.path.startsWith('/en') ? 'en' : 'de';
    this.$store.dispatch('loadData', urlLangDetected).then(function () {
      window.prerenderReady = true;
    });
    this.detectBrowser();
  },

  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["d" /* mapState */])(['error']), Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapGetters */])(['currentPage'])),
  watch: {
    $route: 'resetErrors'
  },
  methods: {
    resetErrors: function resetErrors() {
      this.$store.dispatch('resetError');
    },
    detectBrowser: function detectBrowser() {
      var parse = __webpack_require__(/*! ua-parser-js */ 270);
      var ua = parse(navigator.userAgent);
      this.UABrowser = ua.browser.name + ua.browser.major;
    }
  },
  render: function render(h) {
    return h(
      'div',
      {
        'class': 'App is-page-' + this.currentPage.slug + ' is-' + this.UABrowser,
        attrs: { id: 'app'
        }
      },
      [h(__WEBPACK_IMPORTED_MODULE_3_components_Header__["a" /* default */]), h(__WEBPACK_IMPORTED_MODULE_1_components_Layout__["a" /* default */], [h(
        'transition',
        {
          attrs: { name: 'u-anim-slide-fade-left' }
        },
        [this.error.status ? h(__WEBPACK_IMPORTED_MODULE_2_views_Error__["a" /* default */]) : h('router-view', { key: this.$route.fullPath })]
      )]), h(__WEBPACK_IMPORTED_MODULE_5_components_HomeTeaser__["a" /* default */], {
        attrs: { show: this.$route.name === 'Home' }
      }), h(__WEBPACK_IMPORTED_MODULE_4_components_Footer__["a" /* default */])]
    );
  }
});

/***/ }),
/* 181 */
/*!*********************************!*\
  !*** ./client/styles/main.scss ***!
  \*********************************/
/*! dynamic exports provided */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 182 */
/*!*******************************************!*\
  !*** ./client/components/Layout/index.js ***!
  \*******************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props__ = __webpack_require__(/*! babel-helper-vue-jsx-merge-props */ 5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(/*! vuex */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_gtag__ = __webpack_require__(/*! vue-gtag */ 20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cookie_accept_decline__ = __webpack_require__(/*! vue-cookie-accept-decline */ 183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_cookie_accept_decline_dist_vue_cookie_accept_decline_css__ = __webpack_require__(/*! vue-cookie-accept-decline/dist/vue-cookie-accept-decline.css */ 185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_cookie_accept_decline_dist_vue_cookie_accept_decline_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_cookie_accept_decline_dist_vue_cookie_accept_decline_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_scss__ = __webpack_require__(/*! ./style.scss */ 186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__style_scss__);







var whatInput = __webpack_require__(/*! what-input */ 187);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Layout',
  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */])({
    open: function open(state) {
      return state.ui.menuOpen;
    },
    options: function options(state) {
      return state.data.data.options;
    }
  }), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getStringTranslation', 'lang'])),
  mounted: function mounted() {
    // this.log(whatInput.ask())
  },

  watch: {
    '$route': function $route() {
      var urlLangDetected = this.$route.path.startsWith('/en') ? 'en' : 'de';
      this.$store.dispatch('loadData', urlLangDetected);
      this.$store.dispatch('changeLanguage', urlLangDetected);
    }
  },
  methods: {
    getTranslation: function getTranslation(translationTitle) {
      return this.getStringTranslation(translationTitle);
    },
    cookieStatus: function cookieStatus(e) {
      // console.log('cookieStatus', e)
      if (e === 'decline') {
        // console.log('cookieStatus declined')
      }
      if (e === 'accept') {
        // console.log('cookieStatus accepted')
        this.bootstrapGtag();
      }
    },
    cookieClickedAccept: function cookieClickedAccept(e) {
      // console.log('cookieClickedAccept', e)
      this.bootstrapGtag();
    },
    cookieClickedDecline: function cookieClickedDecline(e) {
      // console.log('cookieClickedDecline', e)
    },
    bootstrapGtag: function bootstrapGtag() {
      Object(__WEBPACK_IMPORTED_MODULE_2_vue_gtag__["a" /* bootstrap */])().then(function (gtag) {
        // console.log('bootstrapped', gtag)
      });
    }
  },
  render: function render(h) {
    var _this = this;

    var options = this.options,
        lang = this.lang;

    return h(
      'div',
      { 'class': 'Layout',
        attrs: { hidden: this.open ? 'hidden' : null
        }
      },
      [h(
        __WEBPACK_IMPORTED_MODULE_3_vue_cookie_accept_decline__["a" /* default */],
        __WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props___default()([{
          ref: 'cookiePanel',
          attrs: { elementId: 'cookiePanel',

            debug: false,
            position: 'bottom',
            type: 'bar',
            disableDecline: false,
            transitionName: '"slideFromBottom"'
          },
          'class': 'VueCookieAcceptDecline__bar' }, {
          on: {
            'status': function status($event) {
              for (var _len = arguments.length, attrs = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                attrs[_key - 1] = arguments[_key];
              }

              _this.cookieStatus.apply(_this, [$event].concat(attrs));
            },
            'clicked-accept': function clickedAccept($event) {
              for (var _len2 = arguments.length, attrs = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
                attrs[_key2 - 1] = arguments[_key2];
              }

              _this.cookieClickedAccept.apply(_this, [$event].concat(attrs));
            },
            'clicked-decline': function clickedDecline($event) {
              for (var _len3 = arguments.length, attrs = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
                attrs[_key3 - 1] = arguments[_key3];
              }

              _this.cookieClickedDecline.apply(_this, [$event].concat(attrs));
            }
          }
        }]),
        [h('div', { slot: 'message', domProps: {
            'innerHTML': options && options.gdpr_cookie_text ? options.gdpr_cookie_text : ''
          }
        }), h(
          'div',
          { slot: 'declineContent' },
          [lang === 'en' ? 'Decline' : 'Ablehnen']
        ), h(
          'div',
          { slot: 'acceptContent' },
          [this.getTranslation('accept')]
        )]
      ), this.$slots.default]
    );
  }
});

/***/ }),
/* 183 */,
/* 184 */
/*!*******************************************************!*\
  !*** ./node_modules/tiny-cookie/dist/tiny-cookie.mjs ***!
  \*******************************************************/
/*! exports provided: get, getAll, getAllCookies, getCookie, getRaw, getRawCookie, isCookieEnabled, isEnabled, remove, removeCookie, set, setCookie, setRaw, setRawCookie */
/*! exports used: get, set */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return get; });
/* unused harmony export getAll */
/* unused harmony export getAllCookies */
/* unused harmony export getCookie */
/* unused harmony export getRaw */
/* unused harmony export getRawCookie */
/* unused harmony export isCookieEnabled */
/* unused harmony export isEnabled */
/* unused harmony export remove */
/* unused harmony export removeCookie */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return set; });
/* unused harmony export setCookie */
/* unused harmony export setRaw */
/* unused harmony export setRawCookie */
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */


var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function hasOwn(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
// Escape special characters.
function escapeRe(str) {
    return str.replace(/[.*+?^$|[\](){}\\-]/g, "\\$&");
}
// Return a future date by the given string.
function computeExpires(str) {
    var lastCh = str.charAt(str.length - 1);
    var value = parseInt(str, 10);
    var expires = new Date();
    switch (lastCh) {
        case "Y":
            expires.setFullYear(expires.getFullYear() + value);
            break;
        case "M":
            expires.setMonth(expires.getMonth() + value);
            break;
        case "D":
            expires.setDate(expires.getDate() + value);
            break;
        case "h":
            expires.setHours(expires.getHours() + value);
            break;
        case "m":
            expires.setMinutes(expires.getMinutes() + value);
            break;
        case "s":
            expires.setSeconds(expires.getSeconds() + value);
            break;
        default:
            expires = new Date(str);
    }
    return expires;
}
// Convert an object to a cookie option string.
function convert(opts) {
    var res = "";
    for (var _i = 0, _a = Object.keys(opts); _i < _a.length; _i++) {
        var key = _a[_i];
        if (/^expires$/i.test(key)) {
            var expires = opts[key];
            var expiresDate = void 0;
            if (typeof expires === "object") {
                expiresDate = expires;
            }
            else {
                expires += typeof expires === "number" ? "D" : "";
                expiresDate = computeExpires(String(expires));
            }
            res += ";".concat(key, "=").concat(expiresDate.toUTCString());
        }
        else if (/^secure|partitioned$/.test(key)) {
            if (opts[key]) {
                res += ";".concat(key);
            }
        }
        else {
            res += ";".concat(key, "=").concat(opts[key]);
        }
    }
    if (!hasOwn(opts, "path")) {
        res += ";path=/";
    }
    return res;
}

// Check if the browser cookie is enabled.
function isEnabled() {
    var key = "@key@";
    var value = "1";
    var re = new RegExp("(?:^|; )".concat(key, "=").concat(value, "(?:;|$)"));
    document.cookie = "".concat(key, "=").concat(value, ";path=/");
    var enabled = re.test(document.cookie);
    if (enabled) {
        // eslint-disable-next-line
        remove(key);
    }
    return enabled;
}
// Get the cookie value by key.
function get(key, decoder) {
    if (decoder === void 0) { decoder = decodeURIComponent; }
    if (typeof key !== "string" || !key) {
        return null;
    }
    var reKey = new RegExp("(?:^|; )".concat(escapeRe(key), "(?:=([^;]*))?(?:;|$)"));
    var match = reKey.exec(document.cookie);
    if (match === null) {
        return null;
    }
    if (typeof decoder === "function") {
        return decoder(match[1]);
    }
    return match[1];
}
// The all cookies
function getAll(decoder) {
    if (decoder === void 0) { decoder = decodeURIComponent; }
    var reKey = /(?:^|; )([^=]+?)(?:=([^;]*))?(?:;|$)/g;
    var cookies = {};
    var match;
    /* eslint-disable no-cond-assign */
    while ((match = reKey.exec(document.cookie))) {
        reKey.lastIndex = match.index + match.length - 1;
        cookies[match[1]] =
            typeof decoder === "function" ? decoder(match[2]) : match[2];
    }
    return cookies;
}
function set(key, value, encoder, options) {
    if (encoder === void 0) { encoder = encodeURIComponent; }
    if (typeof encoder === "object" && encoder !== null) {
        /* eslint-disable no-param-reassign */
        options = encoder;
        encoder = encodeURIComponent;
        /* eslint-enable no-param-reassign */
    }
    var attrsStr = convert(options || {});
    var valueStr = typeof encoder === "function" ? encoder(value) : value;
    var newCookie = "".concat(key, "=").concat(valueStr).concat(attrsStr);
    document.cookie = newCookie;
}
// Remove a cookie by the specified key.
function remove(key, options) {
    var opts = { expires: -1 };
    if (options) {
        opts = __assign(__assign({}, options), opts);
    }
    return set(key, "a", opts);
}
// Get the cookie's value without decoding.
function getRaw(key) {
    return get(key, null);
}
// Set a cookie without encoding the value.
function setRaw(key, value, options) {
    return set(key, value, null, options);
}




/***/ }),
/* 185 */,
/* 186 */
/*!*********************************************!*\
  !*** ./client/components/Layout/style.scss ***!
  \*********************************************/
/*! dynamic exports provided */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 187 */,
/* 188 */
/*!*******************************************!*\
  !*** ./client/common/generateMetaInfo.js ***!
  \*******************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = generateMetaInfo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__generateMetaTitle__ = __webpack_require__(/*! ./generateMetaTitle */ 21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__generateMetaDescription__ = __webpack_require__(/*! ./generateMetaDescription */ 189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__generateMetaImage__ = __webpack_require__(/*! ./generateMetaImage */ 22);




function generateMetaInfo(defaultMeta, post, options) {
  var opts = Object.assign({
    lang: post.polylang.current.lang,
    locale: post.polylang.current.locale
  }, options);
  // console.log('post', post)
  var title = Object(__WEBPACK_IMPORTED_MODULE_0__generateMetaTitle__["a" /* default */])(defaultMeta, post);
  var description = Object(__WEBPACK_IMPORTED_MODULE_1__generateMetaDescription__["a" /* default */])(defaultMeta, post);
  var image = Object(__WEBPACK_IMPORTED_MODULE_2__generateMetaImage__["a" /* default */])(defaultMeta, post);
  var metaInfo = {
    title: title.pageTitle,
    htmlAttrs: {
      lang: opts.lang
    },
    meta: [{ name: 'description', content: description.metaDescription },
    // { name: 'keywords', content: post.keywords },
    // { name: 'author', content: post.author },
    // { property: 'og:locale', content: opts.locale },
    { property: 'og:site_name', content: defaultMeta.og_site_name }, { property: 'og:type', content: 'website' }, { property: 'og:title', content: title.ogTitle }, { property: 'og:description', content: description.ogDescription }, { name: 'twitter:title', content: title.ogTitle }, { name: 'twitter:description', content: description.ogDescription }, { name: 'twitter:card', content: 'summary_large_image'
      // { name: 'twitter:site', content: '@publisher_handle' },
      // { name: 'twitter:creator', content: '@designathon15' },
    }],
    link: []
  };

  if (opts.isHome) {
    if (post.link.endsWith('home/')) {
      post.link = post.link.replace('home/', '');
    }
    if (post.polylang.translations.en && post.polylang.translations.en.permalink.endsWith('home/')) {
      post.polylang.translations.en.permalink = post.polylang.translations.en.permalink.replace('home/', '');
    }
    if (post.polylang.translations.de && post.polylang.translations.de.permalink.endsWith('home/')) {
      post.polylang.translations.de.permalink = post.polylang.translations.de.permalink.replace('home/', '');
    }
  }

  if (!opts.error) {
    if (post.link) {
      metaInfo.link.push({ rel: 'canonical', href: post.link });
    }
  }

  if (!opts.error) {
    if (post.link) {
      metaInfo.meta.push({ property: 'og:url', content: post.link });
    }

    if (post.polylang && post.polylang.translations.en) {
      metaInfo.link.push({ rel: 'alternate', href: post.link, hreflang: 'de' }, { rel: 'alternate', href: post.polylang.translations.en.permalink, hreflang: 'en' });
    } else if (post.polylang && post.polylang.translations.de) {
      metaInfo.link.push({ rel: 'alternate', href: post.link, hreflang: 'en' }, { rel: 'alternate', href: post.polylang.translations.de.permalink, hreflang: 'de' });
    }
  }

  if (image) {
    metaInfo.meta.push({ property: 'og:image', content: image }, { name: 'twitter:image', content: image });
  }

  if (opts.error) {
    metaInfo.meta.push({ name: 'prerender-status-code', content: opts.error });
  }

  return metaInfo;
}

/***/ }),
/* 189 */
/*!**************************************************!*\
  !*** ./client/common/generateMetaDescription.js ***!
  \**************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = generateMetaDescription;
function generateMetaDescription(siteOptions, page) {
  if (siteOptions.default_meta_description) {
    var description = {
      metaDescription: siteOptions.default_meta_description,
      ogDescription: siteOptions.default_meta_description

      // Check for SEO meta description
    };if (page.seo_enabled) {
      // console.log('SEO enabled')
      page.meta_description ? description = {
        metaDescription: page.meta_description,
        ogDescription: page.meta_description
      } : null;
    }

    // Check for OG description
    if (page.og_enabled) {
      // console.log('OG enabled')
      page.og_description ? description.ogDescription = page.og_description : null;
    }

    return description;
  }
}

/***/ }),
/* 190 */,
/* 191 */
/*!********************************************!*\
  !*** ./client/components/Title/style.scss ***!
  \********************************************/
/*! dynamic exports provided */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 192 */
/*!**************************************************!*\
  !*** ./client/components/Breadcrumbs/style.scss ***!
  \**************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 193 */
/*!******************************************!*\
  !*** ./client/util/verifyLeadingLang.js ***!
  \******************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = verifyLeadingLang;
function verifyLeadingLang(string, lang) {
  if (lang === 'en') {
    return string.startsWith('/en/') ? string : '/en' + string;
  } else {
    return string.startsWith('/en/') ? string.substr(3) : string;
  }
}

/***/ }),
/* 194 */
/*!**************************************************!*\
  !*** ./client/components/FlexContent/style.scss ***!
  \**************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 195 */
/*!***********************************************!*\
  !*** ./client/components/RichText/style.scss ***!
  \***********************************************/
/*! dynamic exports provided */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 196 */
/*!*******************************************!*\
  !*** ./client/components/Images/index.js ***!
  \*******************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_scss__ = __webpack_require__(/*! ./style.scss */ 197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Image__ = __webpack_require__(/*! components/Image */ 198);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Images',
  props: ['componentData'],
  render: function render(h) {
    var componentData = this.componentData;

    return h(
      'div',
      { 'class': 'Images' },
      [componentData.map(function (i) {
        return h(__WEBPACK_IMPORTED_MODULE_1_components_Image__["a" /* default */], {
          attrs: { src: i.image, caption: i.caption ? i.caption : '', alt: i.image.alt ? i.image.alt : i.caption ? i.caption : '', fullWidth: i.image_size === 'full' }
        });
      })]
    );
  }
});

/***/ }),
/* 197 */
/*!*********************************************!*\
  !*** ./client/components/Images/style.scss ***!
  \*********************************************/
/*! dynamic exports provided */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 198 */
/*!******************************************!*\
  !*** ./client/components/Image/index.js ***!
  \******************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_scss__ = __webpack_require__(/*! ./style.scss */ 199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_scss__);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Image',
  props: ['src', 'caption', 'alt', 'fullWidth'],
  render: function render(h) {
    var src = this.src,
        caption = this.caption,
        alt = this.alt,
        fullWidth = this.fullWidth;

    return h(
      'figure',
      { 'class': 'Image' + (fullWidth === true ? ' Image--fullwidth' : ' Image--halfwidth') },
      [h('img', {
        attrs: { src: fullWidth === true ? src.sizes.friwi_big : src.sizes.friwi_med, alt: alt },
        'class': 'Image__img' }), caption ? h(
        'figcaption',
        { 'class': 'Image__caption' },
        [caption]
      ) : null]
    );
  }
});

/***/ }),
/* 199 */
/*!********************************************!*\
  !*** ./client/components/Image/style.scss ***!
  \********************************************/
/*! dynamic exports provided */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 200 */
/*!***********************************************!*\
  !*** ./client/components/TeaserGrid/index.js ***!
  \***********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_scss__ = __webpack_require__(/*! ./style.scss */ 201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Teaser__ = __webpack_require__(/*! components/Teaser */ 202);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TeaserGrid',
  props: ['componentData', 'addLinks'],
  render: function render(h) {
    var _this = this;

    var componentData = this.componentData;

    return h(
      'div',
      { 'class': 'TeaserGrid' },
      [componentData.map(function (i) {
        return h(__WEBPACK_IMPORTED_MODULE_1_components_Teaser__["a" /* default */], {
          attrs: { title: i.title, content: i.text ? i.text : null, pageLink: _this.addLinks ? i.page_link : null, image: i.image ? i.image : null }
        });
      })]
    );
  }
});

/***/ }),
/* 201 */
/*!*************************************************!*\
  !*** ./client/components/TeaserGrid/style.scss ***!
  \*************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 202 */
/*!*******************************************!*\
  !*** ./client/components/Teaser/index.js ***!
  \*******************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_scss__ = __webpack_require__(/*! ./style.scss */ 203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_util_getPathFromUrl__ = __webpack_require__(/*! util/getPathFromUrl */ 8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Title__ = __webpack_require__(/*! components/Title */ 4);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Teaser',
  props: {
    'title': {
      type: String
    },
    'content': {
      type: String
    },
    'pageLink': {
      type: String
    },
    'image': {
      type: Object
    }
  },
  computed: {
    internalLinkPath: function internalLinkPath() {
      return this.pageLink ? Object(__WEBPACK_IMPORTED_MODULE_1_util_getPathFromUrl__["a" /* default */])(this.pageLink) : null;
    }
  },
  render: function render(h) {
    var title = this.title,
        content = this.content,
        internalLinkPath = this.internalLinkPath,
        image = this.image;

    return image ? renderImageTeaser(h, title, internalLinkPath, image) : renderTextTeaser(h, title, content, internalLinkPath);
  }
});

function renderImageTeaser(h, title, internalLinkPath, image) {
  return h(
    'div',
    { 'class': 'Teaser Teaser--image' },
    [h(
      'router-link',
      { 'class': 'Teaser__content', attrs: { to: internalLinkPath }
      },
      [h(
        __WEBPACK_IMPORTED_MODULE_2_components_Title__["a" /* default */],
        { 'class': 'Teaser__title', attrs: { level: 3, id: title }
        },
        [title]
      ), h('div', { 'class': 'Teaser__image', style: image ? 'background-image: url(\'' + image.sizes.medium_large + '\')' : '' }), h('img', { 'class': 'Teaser__printImage', attrs: { src: image.sizes.medium_large }
      })]
    ), h(
      __WEBPACK_IMPORTED_MODULE_2_components_Title__["a" /* default */],
      { 'class': 'Teaser__fallback-title', attrs: { level: 3, id: title }
      },
      [title]
    )]
  );
}

function renderTextTeaser(h, title, content, internalLinkPath) {
  return h(
    'div',
    { 'class': 'Teaser Teaser--text' },
    [internalLinkPath ? h(
      'router-link',
      { 'class': 'Teaser__content', attrs: { to: internalLinkPath }
      },
      [h(
        __WEBPACK_IMPORTED_MODULE_2_components_Title__["a" /* default */],
        { 'class': 'Teaser__title', attrs: { level: 3, id: title }
        },
        [title]
      ), h(
        'p',
        { 'class': 'Teaser__text' },
        [content]
      )]
    ) : h(
      'div',
      { 'class': 'Teaser__content' },
      [h(
        __WEBPACK_IMPORTED_MODULE_2_components_Title__["a" /* default */],
        { 'class': 'Teaser__title', attrs: { level: 3, id: title }
        },
        [title]
      ), h(
        'p',
        { 'class': 'Teaser__text' },
        [content]
      )]
    )]
  );
}

/***/ }),
/* 203 */
/*!*********************************************!*\
  !*** ./client/components/Teaser/style.scss ***!
  \*********************************************/
/*! dynamic exports provided */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 204 */
/*!*****************************************************!*\
  !*** ./client/components/AccordionSection/index.js ***!
  \*****************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props__ = __webpack_require__(/*! babel-helper-vue-jsx-merge-props */ 5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(/*! vuex */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mixins_className__ = __webpack_require__(/*! mixins/className */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_uniqueid__ = __webpack_require__(/*! lodash.uniqueid */ 205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_uniqueid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_uniqueid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_RichText__ = __webpack_require__(/*! components/RichText */ 7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_verifyLeadingSlashLang__ = __webpack_require__(/*! util/verifyLeadingSlashLang */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style_scss__ = __webpack_require__(/*! ./style.scss */ 206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__style_scss__);

// Inspired by https://www.w3.org/TR/wai-aria-practices/examples/accordion/accordion.html









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AccordionSection',
  props: {
    section: {
      type: Object,
      default: null
    },
    isNavigation: {
      type: Boolean,
      default: false
    },
    modifiers: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_2_mixins_className__["a" /* default */]],
  data: function data() {
    return {
      uuid: '',
      isExpanded: false
    };
  },
  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['lang'])),
  beforeMount: function beforeMount() {
    this.uuid = __WEBPACK_IMPORTED_MODULE_3_lodash_uniqueid___default()();
  },

  methods: Object.assign({
    handleClick: function handleClick() {
      this.isExpanded = !this.isExpanded;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapMutations */])({
    closeMenu: 'CLOSE_MENU'
  })),
  render: function render(h) {
    var _this = this;

    var section = this.section,
        uuid = this.uuid,
        isExpanded = this.isExpanded,
        isNavigation = this.isNavigation,
        modifiers = this.modifiers,
        handleClick = this.handleClick,
        closeMenu = this.closeMenu,
        lang = this.lang;


    var stateClasses = {
      isHidden: isExpanded ? '' : ' is-hidden',
      isExpanded: isExpanded ? ' is-expanded' : ''
    };

    var headerDefault = h(
      'dt',
      { 'class': 'AccordionSection__header',
        attrs: { role: 'heading',
          'aria-level': '3'
        }
      },
      [h(
        'button',
        __WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props___default()([{ 'class': 'AccordionSection__trigger',
          attrs: { 'aria-expanded': isExpanded,
            'aria-controls': 'accordion-section-' + uuid,
            id: 'accordion-id-' + uuid
          }
        }, {
          on: {
            'click': function click($event) {
              for (var _len = arguments.length, attrs = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                attrs[_key - 1] = arguments[_key];
              }

              handleClick.bind(_this).apply(undefined, [$event].concat(attrs));
            }
          }
        }]),
        [h('span', { 'class': 'AccordionSection__title', domProps: {
            'innerHTML': section.title
          }
        }), h('span', { 'class': 'Accordion-icon' })]
      )]
    );

    var headerNavigation = h(
      'dt',
      { 'class': 'AccordionSection__header',
        attrs: { role: 'heading',
          'aria-level': '3'
        }
      },
      [h(
        'div',
        {
          on: {
            'click': function click($event) {
              for (var _len2 = arguments.length, attrs = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
                attrs[_key2 - 1] = arguments[_key2];
              }

              closeMenu.apply(undefined, [$event].concat(attrs));
            }
          }
        },
        [h(
          'router-link',
          { 'class': 'AccordionSection__header-link', attrs: { to: section.object_slug ? Object(__WEBPACK_IMPORTED_MODULE_5_util_verifyLeadingSlashLang__["a" /* default */])(section.object_slug, lang) : Object(__WEBPACK_IMPORTED_MODULE_5_util_verifyLeadingSlashLang__["a" /* default */])('404', lang) }
          },
          [h('span', { 'class': 'AccordionSection__title',
            domProps: {
              'innerHTML': section.title
            }
          })]
        )]
      ), h('button', __WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props___default()([{ 'class': 'AccordionSection__trigger',
        attrs: { 'aria-expanded': isExpanded,
          'aria-controls': 'accordion-section-' + uuid,
          id: 'accordion-id-' + uuid
        }
      }, {
        on: {
          'click': function click($event) {
            for (var _len3 = arguments.length, attrs = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
              attrs[_key3 - 1] = arguments[_key3];
            }

            handleClick.bind(_this).apply(undefined, [$event].concat(attrs));
          }
        }
      }]))]
    );

    var contentDefault = h(
      'dd',
      { 'class': 'AccordionSection__content' + stateClasses.isHidden,
        attrs: { id: 'accordion-section-' + uuid,
          role: 'region',
          'aria-labelledby': 'accordion-id-' + uuid,
          hidden: stateClasses.isHidden ? 'hidden' : null
        }
      },
      [h(__WEBPACK_IMPORTED_MODULE_4_components_RichText__["a" /* default */], { 'class': 'AccordionSection__content-inner',
        attrs: { content: section.content
        }
      })]
    );

    var contentNavigation = h(
      'dd',
      { 'class': 'AccordionSection__content' + stateClasses.isHidden,
        attrs: { id: 'accordion-section-' + uuid,
          role: 'region',
          'aria-labelledby': 'accordion-id-' + uuid,
          hidden: stateClasses.isHidden ? 'hidden' : null
        }
      },
      [section.children && section.children.length ? h(
        'ul',
        { 'class': 'AccordionSection__list' },
        [section.children.map(function (c) {
          return h(
            'li',
            __WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props___default()([{ 'class': 'AccordionSection__list-item'
            }, {
              on: {
                'click': function click($event) {
                  for (var _len4 = arguments.length, attrs = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
                    attrs[_key4 - 1] = arguments[_key4];
                  }

                  closeMenu.apply(undefined, [$event].concat(attrs));
                }
              }
            }]),
            [h(
              'router-link',
              {
                attrs: { to: Object(__WEBPACK_IMPORTED_MODULE_5_util_verifyLeadingSlashLang__["a" /* default */])(section.object_slug + '/' + c.object_slug, lang) },
                'class': 'AccordionSection__list-item-link' },
              [c.title]
            )]
          );
        })]
      ) : null]
    );

    return section ? h(
      'div',
      { 'class': '' + this.className(this.$options.name, modifiers) + stateClasses.isExpanded },
      [isNavigation ? headerNavigation : headerDefault, isNavigation ? contentNavigation : contentDefault]
    ) : null;
  }
});

/***/ }),
/* 205 */,
/* 206 */
/*!*******************************************************!*\
  !*** ./client/components/AccordionSection/style.scss ***!
  \*******************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 207 */
/*!************************************************!*\
  !*** ./client/components/Accordion/style.scss ***!
  \************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 208 */
/*!************************************************!*\
  !*** ./client/components/LinkGroup/style.scss ***!
  \************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 209 */
/*!*******************************************!*\
  !*** ./client/components/Link/style.scss ***!
  \*******************************************/
/*! dynamic exports provided */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 210 */
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?sourceMap&-autoprefixer!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-685889aa","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?sourceMap!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./client/components/Form/Form.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 211 */,
/* 212 */
/*!***************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/Form/Form.vue ***!
  \***************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_merge__ = __webpack_require__(/*! lodash.merge */ 213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_merge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(/*! axios */ 16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_api_checkProtectedPagePassword__ = __webpack_require__(/*! api/checkProtectedPagePassword */ 232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Title__ = __webpack_require__(/*! components/Title */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_RichText__ = __webpack_require__(/*! components/RichText */ 7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FormLabel__ = __webpack_require__(/*! ./FormLabel */ 234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FormLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__FormLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vee_validate_dist_locale_de__ = __webpack_require__(/*! vee-validate/dist/locale/de */ 237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vee_validate_dist_locale_de___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vee_validate_dist_locale_de__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vee_validate_dist_locale_en__ = __webpack_require__(/*! vee-validate/dist/locale/en */ 238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vee_validate_dist_locale_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vee_validate_dist_locale_en__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










var moment = __webpack_require__(/*! moment */ 0);
__webpack_require__(/*! moment/locale/de */ 18);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Form',
  components: {
    'TitleComponent': __WEBPACK_IMPORTED_MODULE_4_components_Title__["a" /* default */],
    'RichText': __WEBPACK_IMPORTED_MODULE_5_components_RichText__["a" /* default */],
    'FormLabel': __WEBPACK_IMPORTED_MODULE_6__FormLabel___default.a
  },
  props: {
    isLogin: {
      type: Boolean,
      default: false
    },
    buttonText: {
      type: String,
      required: true
    },
    formEndpoint: {
      type: String,
      required: true
    },
    formFields: {
      type: Array,
      required: true
    },
    showConfirmation: {
      type: Boolean
    },
    confirmationTitle: {
      type: String
    },
    confirmationText: {
      type: String
    },
    gdpr: {
      type: Object
    },
    showNewsletterSignup: {
      type: Boolean
    },
    showFeedbackForm: {
      type: Boolean
    },
    feedbackForm: {
      type: Object
    }
  },
  data: function data() {
    return {
      veeValidateDictionary: {
        de: {
          messages: __WEBPACK_IMPORTED_MODULE_7_vee_validate_dist_locale_de___default.a.messages
        },
        en: {
          messages: __WEBPACK_IMPORTED_MODULE_8_vee_validate_dist_locale_en___default.a.messages
        }
      },
      formState: {},
      success: false,
      passwordError: false,
      gdprFieldName: false, // is set via string translation
      customValidations: {
        email: {
          email: true
        },
        numeric: {
          numeric: true
        },
        zip: {
          numeric: true,
          min: 4,
          max: 5
        },
        phone: {
          min: 9
        }
      }
    };
  },

  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["d" /* mapState */])({
    options: function options(state) {
      return state.data.data.options;
    }
  }), Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['currentPage', 'getStringTranslation', 'lang'])),
  watch: {
    lang: function lang() {
      this.$validator.localize(this.lang, this.veeValidateDictionary[this.lang]);
    },
    success: function success() {
      var _this = this;

      // scroll to success notification when transition has completed
      setTimeout(function () {
        window.scrollTo(0, _this.$refs.formSuccess.offsetTop - 100);
      }, 500);
    }
  },
  created: function created() {
    this.$validator.localize('de', this.veeValidateDictionary.de);
    this.gdprFieldName = this.getStringTranslation('gdpr');
  },
  mounted: function mounted() {
    this.$validator.localize(this.lang, this.veeValidateDictionary[this.lang]);

    // Add some required fields
    this.formState.email = '';
  },

  methods: {
    onChangeHandler: function onChangeHandler() {},
    submitHandler: function submitHandler(e) {
      var _this2 = this;

      if (this.isLogin) {
        if (this.formState.password) {
          // console.log('password in form: ' + this.formState.password)
          // this.$store.dispatch('checkProtectedPagePassword', this.formState.password)
          Object(__WEBPACK_IMPORTED_MODULE_3_api_checkProtectedPagePassword__["a" /* default */])({ id: this.currentPage.id, password: this.formState.password }).then(function (response) {
            _this2.passwordError = false;
            _this2.$store.dispatch('authenticatePage');
          }).catch(function (err) {
            _this2.passwordError = true;
            console.log(err);
          });
        }
      } else {
        // console.log(this.formState)
        this.$validator.validateAll().then(function (result) {
          // console.log({result})
          if (result) {
            var sortObjectByList = function sortObjectByList(originalObject, firstFields) {
              var sortedObject = {};

              // Add keys from firstFields if they exist in the original object
              firstFields.forEach(function (field) {
                if (originalObject.hasOwnProperty(field)) {
                  sortedObject[field] = originalObject[field];
                }
              });

              // Add remaining keys from the original object
              Object.keys(originalObject).forEach(function (key) {
                if (!sortedObject.hasOwnProperty(key)) {
                  sortedObject[key] = originalObject[key];
                }
              });

              return sortedObject;
            };

            // If present we want to have these items first and the other fields after


            // Add today's date
            _this2.formState['Gesendet am'] = moment().format('LLLL');

            var dataToBeSubmitted = Object.assign({}, _this2.formState);

            // Delete all fields with false value
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = Object.entries(dataToBeSubmitted)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var _ref = _step.value;

                var _ref2 = _slicedToArray(_ref, 2);

                var key = _ref2[0];
                var value = _ref2[1];

                if (value === false) delete dataToBeSubmitted[key];
              }

              // Translate booleans to Ja/Nein
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }

            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = Object.entries(dataToBeSubmitted)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var _ref3 = _step2.value;

                var _ref4 = _slicedToArray(_ref3, 2);

                var _key = _ref4[0];
                var _value = _ref4[1];

                if (typeof _value === 'boolean') dataToBeSubmitted[_key] = _this2.translateBooleanToGerman(_value);
              }

              // Delete email field if emtpy
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }

            if (dataToBeSubmitted.email === '') delete dataToBeSubmitted.email;

            var firstFields = ['Gesendet am', 'email', 'Newsletter', 'Datenschutz', 'Vorname', 'Nachname', 'Firma', 'Strasse', 'Strasse Nr', 'PLZ', 'Ort', 'Land', 'Telefon', 'Bemerkung'];

            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
              for (var _iterator3 = Object.entries(dataToBeSubmitted)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                var _ref5 = _step3.value;

                var _ref6 = _slicedToArray(_ref5, 2);

                var _key2 = _ref6[0];
                var _value2 = _ref6[1];

                if (_key2.includes('–')) {
                  var newKey = _key2.replaceAll('.–', ' ').replaceAll('–', '-').replaceAll('\'', '').replaceAll(',', ' -').replaceAll('.', '-').replaceAll('(', '').replaceAll(')', '');
                  var newKeyNoUmlaute = _this2.replaceUmlaute(newKey);
                  dataToBeSubmitted[newKeyNoUmlaute] = _value2;
                  delete dataToBeSubmitted[_key2];
                }
              }

              // console.log(dataToBeSubmitted)
            } catch (err) {
              _didIteratorError3 = true;
              _iteratorError3 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }
              } finally {
                if (_didIteratorError3) {
                  throw _iteratorError3;
                }
              }
            }

            var sortedDataToBeSubmitted = sortObjectByList(dataToBeSubmitted, firstFields);
            // console.log(sortedDataToBeSubmitted)


            // axios.post('https://formbucket.com/f/buk_Wyhi4MCaemB8r2KygKkhmdmU', sortedDataToBeSubmitted)
            __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(_this2.formEndpoint, sortedDataToBeSubmitted).then(function (response) {
              // console.log(response)
              this.success = true;
            }.bind(_this2)).catch(function (error) {
              console.log(error);
            });
            return;
          } else {
            // console.log('Correct the errors!')
            // scroll to the first erroneous element
            var firstErrorElement = document.querySelectorAll('[name="' + _this2.veeValidateErrors.items[0].field + '"]');
            window.scrollTo(0, firstErrorElement[0].offsetTop - 100);
          }
        });
      }
    },
    constructValidation: function constructValidation(type) {
      var validation = {
        required: true
      };
      switch (type) {
        case 'numeric':
          validation = __WEBPACK_IMPORTED_MODULE_1_lodash_merge___default()(validation, this.customValidations.numeric);
          break;
        case 'zip':
          validation = __WEBPACK_IMPORTED_MODULE_1_lodash_merge___default()(validation, this.customValidations.zip);
          break;
        case 'email':
          validation = __WEBPACK_IMPORTED_MODULE_1_lodash_merge___default()(validation, this.customValidations.email);
          break;
        case 'phone':
          validation = __WEBPACK_IMPORTED_MODULE_1_lodash_merge___default()(validation, this.customValidations.phone);
          break;
        default:
          break;
      }
      // console.log(type, validation)
      return validation;
    },
    cleanLabel: function cleanLabel() {
      var label = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      // First replace umlauts with ae, ue, etc.
      var withoutUmlauts = this.replaceUmlaute(label);
      // Finally slugify
      var slugified = this.slugify(withoutUmlauts);
      return slugified;
    },
    translateBooleanToGerman: function translateBooleanToGerman(booleanVal) {
      if (booleanVal) {
        return 'Ja';
      } else {
        return 'Nein';
      }
    },
    replaceUmlaute: function replaceUmlaute(str) {
      var umlautMap = {
        '\xDC': 'UE',
        '\xC4': 'AE',
        '\xD6': 'OE',
        '\xFC': 'ue',
        '\xE4': 'ae',
        '\xF6': 'oe',
        '\xDF': 'ss'
      };

      return str.replace(/[\u00dc|\u00c4|\u00d6][a-z]/g, function (a) {
        var big = umlautMap[a.slice(0, 1)];
        return big.charAt(0) + big.charAt(1).toLowerCase() + a.slice(1);
      }).replace(new RegExp('[' + Object.keys(umlautMap).join('|') + ']', "g"), function (a) {
        return umlautMap[a];
      });
    },
    slugify: function slugify(str) {
      var a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìıİłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;';
      var b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------';
      var p = new RegExp(a.split('').join('|'), 'g');

      var slugified = str.toString().toLowerCase().replace(/\s+/g, '-') // Replace spaces with -
      .replace(p, function (c) {
        return b.charAt(a.indexOf(c));
      }) // Replace special characters
      .replace(/&/g, '-and-') // Replace & with 'and'
      .replace(/[^\w\-]+/g, '') // Remove all non-word characters
      .replace(/\-\-+/g, '-') // Replace multiple - with single -
      .replace(/^-+/, '') // Trim - from start of text
      .replace(/-+$/, ''); // Trim - from end of text

      return slugified;
    }
  }
});

/***/ }),
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */
/*!**************************************************!*\
  !*** ./client/api/checkProtectedPagePassword.js ***!
  \**************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = checkProtectedPagePassword;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(/*! ../config */ 233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(/*! axios */ 16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



function checkProtectedPagePassword(_ref) {
  var _ref$id = _ref.id,
      id = _ref$id === undefined ? '' : _ref$id,
      _ref$password = _ref.password,
      password = _ref$password === undefined ? '' : _ref$password;

  // console.log(`${CONFIG.API_URL}/wp/v2/pages/${id}?password=${password}`)
  return new Promise(function (resolve, reject) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].API_URL + '/wp/v2/pages/' + id + '?password=' + password).then(function (response) {
      resolve(response.status);
    }).catch(function (response) {
      return reject(response);
    });
  });
}

/***/ }),
/* 233 */
/*!**************************!*\
  !*** ./client/config.js ***!
  \**************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var CONFIG = Object.assign({
  API_URL: 'https://api.frischerwind.com/api'
}, window.APP_CONFIG || {});

/* harmony default export */ __webpack_exports__["a"] = (CONFIG);

/***/ }),
/* 234 */
/*!**********************************************!*\
  !*** ./client/components/Form/FormLabel.vue ***!
  \**********************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 28)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./FormLabel.vue */ 235),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-11afda8e","hasScoped":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./FormLabel.vue */ 236),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 235 */
/*!********************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/Form/FormLabel.vue ***!
  \********************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FormLabel',
  props: {
    cleanLabel: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    required: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),
/* 236 */
/*!*********************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11afda8e","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/Form/FormLabel.vue ***!
  \*********************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    class: ("Form__label Form__label--" + _vm.cleanLabel),
    attrs: {
      "for": _vm.cleanLabel
    }
  }, [_c('span', {
    staticClass: "Form__label-text"
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), (_vm.required) ? _c('abbr', {
    staticClass: "Form__label-required",
    attrs: {
      "title": "required"
    }
  }, [_vm._v("*")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 237 */,
/* 238 */,
/* 239 */
/*!*********************************************!*\
  !*** ./node_modules/moment/locale ^\.\/.*$ ***!
  \*********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 35,
	"./af.js": 35,
	"./ar": 36,
	"./ar-dz": 37,
	"./ar-dz.js": 37,
	"./ar-kw": 38,
	"./ar-kw.js": 38,
	"./ar-ly": 39,
	"./ar-ly.js": 39,
	"./ar-ma": 40,
	"./ar-ma.js": 40,
	"./ar-ps": 41,
	"./ar-ps.js": 41,
	"./ar-sa": 42,
	"./ar-sa.js": 42,
	"./ar-tn": 43,
	"./ar-tn.js": 43,
	"./ar.js": 36,
	"./az": 44,
	"./az.js": 44,
	"./be": 45,
	"./be.js": 45,
	"./bg": 46,
	"./bg.js": 46,
	"./bm": 47,
	"./bm.js": 47,
	"./bn": 48,
	"./bn-bd": 49,
	"./bn-bd.js": 49,
	"./bn.js": 48,
	"./bo": 50,
	"./bo.js": 50,
	"./br": 51,
	"./br.js": 51,
	"./bs": 52,
	"./bs.js": 52,
	"./ca": 53,
	"./ca.js": 53,
	"./cs": 54,
	"./cs.js": 54,
	"./cv": 55,
	"./cv.js": 55,
	"./cy": 56,
	"./cy.js": 56,
	"./da": 57,
	"./da.js": 57,
	"./de": 18,
	"./de-at": 58,
	"./de-at.js": 58,
	"./de-ch": 59,
	"./de-ch.js": 59,
	"./de.js": 18,
	"./dv": 60,
	"./dv.js": 60,
	"./el": 61,
	"./el.js": 61,
	"./en-au": 62,
	"./en-au.js": 62,
	"./en-ca": 63,
	"./en-ca.js": 63,
	"./en-gb": 64,
	"./en-gb.js": 64,
	"./en-ie": 65,
	"./en-ie.js": 65,
	"./en-il": 66,
	"./en-il.js": 66,
	"./en-in": 67,
	"./en-in.js": 67,
	"./en-nz": 68,
	"./en-nz.js": 68,
	"./en-sg": 69,
	"./en-sg.js": 69,
	"./eo": 70,
	"./eo.js": 70,
	"./es": 71,
	"./es-do": 72,
	"./es-do.js": 72,
	"./es-mx": 73,
	"./es-mx.js": 73,
	"./es-us": 74,
	"./es-us.js": 74,
	"./es.js": 71,
	"./et": 75,
	"./et.js": 75,
	"./eu": 76,
	"./eu.js": 76,
	"./fa": 77,
	"./fa.js": 77,
	"./fi": 78,
	"./fi.js": 78,
	"./fil": 79,
	"./fil.js": 79,
	"./fo": 80,
	"./fo.js": 80,
	"./fr": 81,
	"./fr-ca": 82,
	"./fr-ca.js": 82,
	"./fr-ch": 83,
	"./fr-ch.js": 83,
	"./fr.js": 81,
	"./fy": 84,
	"./fy.js": 84,
	"./ga": 85,
	"./ga.js": 85,
	"./gd": 86,
	"./gd.js": 86,
	"./gl": 87,
	"./gl.js": 87,
	"./gom-deva": 88,
	"./gom-deva.js": 88,
	"./gom-latn": 89,
	"./gom-latn.js": 89,
	"./gu": 90,
	"./gu.js": 90,
	"./he": 91,
	"./he.js": 91,
	"./hi": 92,
	"./hi.js": 92,
	"./hr": 93,
	"./hr.js": 93,
	"./hu": 94,
	"./hu.js": 94,
	"./hy-am": 95,
	"./hy-am.js": 95,
	"./id": 96,
	"./id.js": 96,
	"./is": 97,
	"./is.js": 97,
	"./it": 98,
	"./it-ch": 99,
	"./it-ch.js": 99,
	"./it.js": 98,
	"./ja": 100,
	"./ja.js": 100,
	"./jv": 101,
	"./jv.js": 101,
	"./ka": 102,
	"./ka.js": 102,
	"./kk": 103,
	"./kk.js": 103,
	"./km": 104,
	"./km.js": 104,
	"./kn": 105,
	"./kn.js": 105,
	"./ko": 106,
	"./ko.js": 106,
	"./ku": 107,
	"./ku-kmr": 108,
	"./ku-kmr.js": 108,
	"./ku.js": 107,
	"./ky": 109,
	"./ky.js": 109,
	"./lb": 110,
	"./lb.js": 110,
	"./lo": 111,
	"./lo.js": 111,
	"./lt": 112,
	"./lt.js": 112,
	"./lv": 113,
	"./lv.js": 113,
	"./me": 114,
	"./me.js": 114,
	"./mi": 115,
	"./mi.js": 115,
	"./mk": 116,
	"./mk.js": 116,
	"./ml": 117,
	"./ml.js": 117,
	"./mn": 118,
	"./mn.js": 118,
	"./mr": 119,
	"./mr.js": 119,
	"./ms": 120,
	"./ms-my": 121,
	"./ms-my.js": 121,
	"./ms.js": 120,
	"./mt": 122,
	"./mt.js": 122,
	"./my": 123,
	"./my.js": 123,
	"./nb": 124,
	"./nb.js": 124,
	"./ne": 125,
	"./ne.js": 125,
	"./nl": 126,
	"./nl-be": 127,
	"./nl-be.js": 127,
	"./nl.js": 126,
	"./nn": 128,
	"./nn.js": 128,
	"./oc-lnc": 129,
	"./oc-lnc.js": 129,
	"./pa-in": 130,
	"./pa-in.js": 130,
	"./pl": 131,
	"./pl.js": 131,
	"./pt": 132,
	"./pt-br": 133,
	"./pt-br.js": 133,
	"./pt.js": 132,
	"./ro": 134,
	"./ro.js": 134,
	"./ru": 135,
	"./ru.js": 135,
	"./sd": 136,
	"./sd.js": 136,
	"./se": 137,
	"./se.js": 137,
	"./si": 138,
	"./si.js": 138,
	"./sk": 139,
	"./sk.js": 139,
	"./sl": 140,
	"./sl.js": 140,
	"./sq": 141,
	"./sq.js": 141,
	"./sr": 142,
	"./sr-cyrl": 143,
	"./sr-cyrl.js": 143,
	"./sr.js": 142,
	"./ss": 144,
	"./ss.js": 144,
	"./sv": 145,
	"./sv.js": 145,
	"./sw": 146,
	"./sw.js": 146,
	"./ta": 147,
	"./ta.js": 147,
	"./te": 148,
	"./te.js": 148,
	"./tet": 149,
	"./tet.js": 149,
	"./tg": 150,
	"./tg.js": 150,
	"./th": 151,
	"./th.js": 151,
	"./tk": 152,
	"./tk.js": 152,
	"./tl-ph": 153,
	"./tl-ph.js": 153,
	"./tlh": 154,
	"./tlh.js": 154,
	"./tr": 155,
	"./tr.js": 155,
	"./tzl": 156,
	"./tzl.js": 156,
	"./tzm": 157,
	"./tzm-latn": 158,
	"./tzm-latn.js": 158,
	"./tzm.js": 157,
	"./ug-cn": 159,
	"./ug-cn.js": 159,
	"./uk": 160,
	"./uk.js": 160,
	"./ur": 161,
	"./ur.js": 161,
	"./uz": 162,
	"./uz-latn": 163,
	"./uz-latn.js": 163,
	"./uz.js": 162,
	"./vi": 164,
	"./vi.js": 164,
	"./x-pseudo": 165,
	"./x-pseudo.js": 165,
	"./yo": 166,
	"./yo.js": 166,
	"./zh-cn": 167,
	"./zh-cn.js": 167,
	"./zh-hk": 168,
	"./zh-hk.js": 168,
	"./zh-mo": 169,
	"./zh-mo.js": 169,
	"./zh-tw": 170,
	"./zh-tw.js": 170
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 239;

/***/ }),
/* 240 */
/*!****************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-685889aa","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/Form/Form.vue ***!
  \****************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    ref: "form",
    class: _vm.isLogin ? 'Form is-login' : 'Form',
    attrs: {
      "name": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('transition-group', {
    staticClass: "Form__transition-group",
    attrs: {
      "name": "u-anim-fade-delayed",
      "tag": "div"
    }
  }, [(_vm.success) ? _c('div', {
    key: "success",
    ref: "formSuccess",
    staticClass: "Form__container"
  }, [_c('div', {
    staticClass: "Form__section Form__section--success"
  }, [(_vm.showConfirmation) ? _c('div', {
    staticClass: "Form__section-inner"
  }, [_c('TitleComponent', {
    staticClass: "Form__confirmationTitle",
    attrs: {
      "level": 2,
      "id": _vm.confirmationTitle
    }
  }, [_vm._v(_vm._s(_vm.confirmationTitle))]), _vm._v(" "), _c('RichText', {
    attrs: {
      "content": _vm.confirmationText
    }
  }), _vm._v(" "), (_vm.showNewsletterSignup && _vm.formState['Newsletter']) ? _c('p', [_c('br'), _c('br'), _vm._v(_vm._s(_vm.options.newsletter_signup_confirmation_text))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.showFeedbackForm && _vm.feedbackForm) ? _c('Form', {
    attrs: {
      "name": "feedbackForm",
      "formFields": _vm.feedbackForm.form_fields,
      "buttonText": _vm.feedbackForm.button_text,
      "formEndpoint": _vm.feedbackForm.form_endpoint,
      "showConfirmation": _vm.feedbackForm.show_confirmation,
      "confirmationTitle": _vm.feedbackForm.confirmation_title,
      "confirmationText": _vm.feedbackForm.confirmation_text,
      "gdpr": false,
      "showNewsletterSignup": false,
      "showFeedbackForm": false,
      "feedbackForm": false
    }
  }) : _vm._e()], 1)]) : _c('div', {
    key: "else",
    staticClass: "Form__container"
  }, [_vm._l((_vm.formFields), function(field, index) {
    return _c('div', {
      key: index,
      class: ("Form__section Form__section--" + (field.type))
    }, [(field.type === 'description') ? _c('div', [_c('div', {
      class: ("Form__field-wrapper Form__field-wrapper--" + (field.type))
    }, [(field.type === 'description') ? _c('RichText', {
      attrs: {
        "content": field.content
      }
    }) : _vm._e()], 1)]) : (field.type === 'street_number') ? _c('div', [_c('div', {
      staticClass: "clearfix"
    }, [_c('div', {
      staticClass: "Form__section-inner Form__section-inner--street"
    }, [_c('FormLabel', {
      attrs: {
        "label": _vm.getStringTranslation('form_street'),
        "cleanLabel": "street",
        "required": field.required
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "Form__field-wrapper Form__field-wrapper--street"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.formState['Strasse']),
        expression: "formState['Strasse']"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: (field.required ? _vm.constructValidation() : false),
        expression: "field.required ? constructValidation() : false"
      }],
      staticClass: "Form__field Form__field--street",
      attrs: {
        "type": "text",
        "id": "street",
        "name": _vm.getStringTranslation('form_street')
      },
      domProps: {
        "value": (_vm.formState['Strasse'])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.formState, 'Strasse', $event.target.value)
        }
      }
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "Form__section-inner Form__section-inner--street-number"
    }, [_c('FormLabel', {
      attrs: {
        "label": _vm.getStringTranslation('form_number'),
        "cleanLabel": "street-number",
        "required": field.required
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "Form__field-wrapper Form__field-wrapper--street-number"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.formState['Strasse Nr']),
        expression: "formState['Strasse Nr']"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: (field.required ? _vm.constructValidation() : false),
        expression: "field.required ? constructValidation() : false"
      }],
      staticClass: "Form__field Form__field--street-number",
      attrs: {
        "type": "text",
        "id": "street-number",
        "name": _vm.getStringTranslation('form_number')
      },
      domProps: {
        "value": (_vm.formState['Strasse Nr'])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.formState, 'Strasse Nr', $event.target.value)
        }
      }
    })])], 1)]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.veeValidateErrors.has(_vm.getStringTranslation('form_street'))),
        expression: "veeValidateErrors.has(getStringTranslation('form_street'))"
      }],
      staticClass: "Form__error"
    }, [_vm._v("\n            " + _vm._s(_vm.veeValidateErrors.first(_vm.getStringTranslation('form_street'))) + "\n          ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.veeValidateErrors.has(_vm.getStringTranslation('form_number'))),
        expression: "veeValidateErrors.has(getStringTranslation('form_number'))"
      }],
      staticClass: "Form__error"
    }, [_vm._v("\n            " + _vm._s(_vm.veeValidateErrors.first(_vm.getStringTranslation('form_number'))) + "\n          ")])]) : (field.type === 'zip_place') ? _c('div', [_c('div', {
      staticClass: "clearfix"
    }, [_c('div', {
      staticClass: "Form__section-inner Form__section-inner--zip"
    }, [_c('FormLabel', {
      attrs: {
        "label": _vm.getStringTranslation('form_zip'),
        "cleanLabel": "zip",
        "required": field.required
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "Form__field-wrapper Form__field-wrapper--zip"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.formState['PLZ']),
        expression: "formState['PLZ']"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: (field.required ? _vm.constructValidation('zip') : false),
        expression: "field.required ? constructValidation('zip') : false"
      }],
      staticClass: "Form__field Form__field--zip",
      attrs: {
        "type": "text",
        "id": "zip",
        "name": _vm.getStringTranslation('form_zip')
      },
      domProps: {
        "value": (_vm.formState['PLZ'])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.formState, 'PLZ', $event.target.value)
        }
      }
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "Form__section-inner Form__section-inner--place"
    }, [_c('FormLabel', {
      attrs: {
        "label": _vm.getStringTranslation('form_city'),
        "cleanLabel": "place",
        "required": field.required
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "Form__field-wrapper Form__field-wrapper--place"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.formState['Ort']),
        expression: "formState['Ort']"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: (field.required ? _vm.constructValidation() : false),
        expression: "field.required ? constructValidation() : false"
      }],
      staticClass: "Form__field Form__field--place",
      attrs: {
        "type": "text",
        "id": "place",
        "name": _vm.getStringTranslation('form_city')
      },
      domProps: {
        "value": (_vm.formState['Ort'])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.formState, 'Ort', $event.target.value)
        }
      }
    })])], 1)]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.veeValidateErrors.has(_vm.getStringTranslation('form_zip'))),
        expression: "veeValidateErrors.has(getStringTranslation('form_zip'))"
      }],
      staticClass: "Form__error"
    }, [_vm._v("\n            " + _vm._s(_vm.veeValidateErrors.first(_vm.getStringTranslation('form_zip'))) + "\n          ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.veeValidateErrors.has(_vm.getStringTranslation('form_city'))),
        expression: "veeValidateErrors.has(getStringTranslation('form_city'))"
      }],
      staticClass: "Form__error"
    }, [_vm._v("\n            " + _vm._s(_vm.veeValidateErrors.first(_vm.getStringTranslation('form_city'))) + "\n          ")])]) : (field.type === 'swiss_only') ? _c('div', [_c('FormLabel', {
      attrs: {
        "label": "Land",
        "cleanLabel": "country"
      }
    }), _vm._v(" "), _c('div', {
      class: "Form__field-wrapper Form__field-wrapper--text"
    }, [_c('input', {
      class: "Form__field Form__field--text",
      attrs: {
        "value": "Schweiz",
        "type": "text",
        "id": "country",
        "name": "country",
        "readonly": ""
      }
    })])], 1) : (field.type === 'quantity') ? _c('div', [_c('FormLabel', {
      attrs: {
        "label": "Anzahl *",
        "cleanLabel": "quantity"
      }
    }), _vm._v(" "), _c('div', {
      class: "Form__field-wrapper Form__field-wrapper--text"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.formState['Anzahl']),
        expression: "formState['Anzahl']"
      }],
      class: "Form__field Form__field--quantity",
      attrs: {
        "type": "number",
        "min": "1",
        "id": "quantity",
        "name": "quantity"
      },
      domProps: {
        "value": (_vm.formState['Anzahl'])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.formState, 'Anzahl', $event.target.value)
        }
      }
    })])], 1) : (field.type === 'radiogroup') ? _c('div', [_c('fieldset', {
      staticClass: "Form__section-fieldset"
    }, [_c('legend', {
      staticClass: "Form__section-legend"
    }, [_c('TitleComponent', {
      staticClass: "Form__section-title",
      attrs: {
        "level": 4
      }
    }, [_vm._v("\n                " + _vm._s(field.label) + "\n                "), (field.required) ? _c('abbr', {
      staticClass: "Form__label-required",
      attrs: {
        "title": "required"
      }
    }, [_vm._v("*")]) : _vm._e()])], 1), _vm._v(" "), _vm._l((field.radio_group_options), function(option, index) {
      return _c('div', {
        key: index,
        staticClass: "Form__section-radio-item"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.formState['Option']),
          expression: "formState['Option']"
        }],
        staticClass: "Form__section-radio-item-input",
        attrs: {
          "type": "radio",
          "name": field.label,
          "id": ("radio-item-" + index)
        },
        domProps: {
          "value": option.option,
          "checked": _vm._q(_vm.formState['Option'], option.option)
        },
        on: {
          "change": function($event) {
            return _vm.$set(_vm.formState, 'Option', option.option)
          }
        }
      }), _vm._v(" "), _c('label', {
        staticClass: "Form__label Form__label--radio",
        attrs: {
          "for": ("radio-item-" + index)
        }
      }, [_vm._v("\n                " + _vm._s(option.option) + "\n              ")]), _vm._v(" "), _c('div', {
        style: ({
          clear: 'both'
        })
      })])
    })], 2)]) : (field.type === 'textarea') ? _c('div', [_c('FormLabel', {
      attrs: {
        "label": field.label,
        "cleanLabel": _vm.cleanLabel(field.label),
        "required": field.required
      }
    }), _vm._v(" "), _c('div', {
      class: ("Form__field-wrapper Form__field-wrapper--" + (field.type))
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.formState[field.label]),
        expression: "formState[field.label]"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: (field.required ? _vm.constructValidation() : false),
        expression: "field.required ? constructValidation() : false"
      }],
      class: ("Form__field Form__field--" + (field.type)),
      attrs: {
        "id": _vm.cleanLabel(field.label),
        "name": field.label
      },
      domProps: {
        "value": (_vm.formState[field.label])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.formState, field.label, $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.veeValidateErrors.has(field.label)),
        expression: "veeValidateErrors.has(field.label)"
      }],
      staticClass: "Form__error"
    }, [_vm._v("\n              " + _vm._s(_vm.veeValidateErrors.first(field.label)) + "\n            ")])])], 1) : (field.type === 'password') ? _c('div', [_c('FormLabel', {
      attrs: {
        "label": field.label,
        "cleanLabel": _vm.cleanLabel(field.label),
        "required": field.required
      }
    }), _vm._v(" "), _c('div', {
      class: ("Form__field-wrapper Form__field-wrapper--" + (field.type))
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.formState[field.type]),
        expression: "formState[field.type]"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: (_vm.constructValidation(field.type)),
        expression: "constructValidation(field.type)"
      }],
      class: ("Form__field Form__field--" + (field.type)),
      attrs: {
        "type": "password",
        "id": _vm.cleanLabel(field.label),
        "name": field.label
      },
      domProps: {
        "value": (_vm.formState[field.type])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.formState, field.type, $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.veeValidateErrors.has(field.label)),
        expression: "veeValidateErrors.has(field.label)"
      }],
      staticClass: "Form__error"
    }, [_vm._v("\n              " + _vm._s(_vm.veeValidateErrors.first(field.label)) + "\n            ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.passwordError),
        expression: "passwordError"
      }],
      staticClass: "Form__error"
    }, [_vm._v("\n              " + _vm._s(_vm.getStringTranslation('error_wrongpassword')) + "\n            ")])])], 1) : (field.type === 'checkbox') ? _c('div', [_c('div', {
      staticClass: "Form__field-wrapper Form__field-wrapper--checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.formState[field.label]),
        expression: "formState[field.label]"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: (field.required ? 'required' : false),
        expression: "field.required ? 'required' : false"
      }],
      staticClass: "Form__field--checkbox",
      attrs: {
        "type": "checkbox",
        "id": _vm.cleanLabel(field.label),
        "name": field.label
      },
      domProps: {
        "checked": Array.isArray(_vm.formState[field.label]) ? _vm._i(_vm.formState[field.label], null) > -1 : (_vm.formState[field.label])
      },
      on: {
        "change": function($event) {
          var $$a = _vm.formState[field.label],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.formState, field.label, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.formState, field.label, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.formState, field.label, $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "Form__label--checkbox",
      attrs: {
        "for": _vm.cleanLabel(field.label)
      }
    }, [_vm._v("\n              " + _vm._s(field.required ? '* ' : '') + _vm._s(field.label) + "\n            ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.veeValidateErrors.has(field.label)),
        expression: "veeValidateErrors.has(field.label)"
      }],
      staticClass: "Form__error"
    }, [_vm._v("\n              " + _vm._s(_vm.veeValidateErrors.first(field.label)) + "\n            ")])])]) : (field.type === 'email') ? _c('div', [_c('FormLabel', {
      attrs: {
        "label": field.label,
        "cleanLabel": _vm.cleanLabel(field.label),
        "required": field.required
      }
    }), _vm._v(" "), _c('div', {
      class: ("Form__field-wrapper Form__field-wrapper--" + (field.type))
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.formState.email),
        expression: "formState.email"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: (field.required ? _vm.constructValidation(field.type) : false),
        expression: "field.required ? constructValidation(field.type) : false"
      }],
      class: ("Form__field Form__field--" + (field.type)),
      attrs: {
        "type": "text",
        "id": _vm.cleanLabel(field.label),
        "name": field.label
      },
      domProps: {
        "value": (_vm.formState.email)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.formState, "email", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.veeValidateErrors.has(field.label)),
        expression: "veeValidateErrors.has(field.label)"
      }],
      staticClass: "Form__error"
    }, [_vm._v("\n              " + _vm._s(_vm.veeValidateErrors.first(field.label)) + "\n            ")])])], 1) : _c('div', [_c('FormLabel', {
      attrs: {
        "label": field.label,
        "cleanLabel": _vm.cleanLabel(field.label),
        "required": field.required
      }
    }), _vm._v(" "), _c('div', {
      class: ("Form__field-wrapper Form__field-wrapper--" + (field.type))
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.formState[field.label]),
        expression: "formState[field.label]"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: (field.required ? _vm.constructValidation(field.type) : false),
        expression: "field.required ? constructValidation(field.type) : false"
      }],
      class: ("Form__field Form__field--" + (field.type)),
      attrs: {
        "type": "text",
        "id": _vm.cleanLabel(field.label),
        "name": field.label
      },
      domProps: {
        "value": (_vm.formState[field.label])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.formState, field.label, $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.veeValidateErrors.has(field.label)),
        expression: "veeValidateErrors.has(field.label)"
      }],
      staticClass: "Form__error"
    }, [_vm._v("\n              " + _vm._s(_vm.veeValidateErrors.first(field.label)) + "\n            ")])])], 1)])
  }), _vm._v(" "), (_vm.showNewsletterSignup && _vm.options && _vm.options.newsletter_signup_title && _vm.options.newsletter_signup_text && _vm.options.newsletter_signup_confirmation_text) ? _c('div', {
    staticClass: "Form__section Form__section--gdpr"
  }, [_c('span', [_vm._v("\n          " + _vm._s(_vm.options.newsletter_signup_title) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "Form__field-wrapper Form__field-wrapper--checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formState['Newsletter']),
      expression: "formState['Newsletter']"
    }],
    staticClass: "Form__field--checkbox",
    attrs: {
      "type": "checkbox",
      "id": 'newsletter',
      "name": 'newsletter'
    },
    domProps: {
      "checked": Array.isArray(_vm.formState['Newsletter']) ? _vm._i(_vm.formState['Newsletter'], null) > -1 : (_vm.formState['Newsletter'])
    },
    on: {
      "change": function($event) {
        var $$a = _vm.formState['Newsletter'],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.formState, 'Newsletter', $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.formState, 'Newsletter', $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.formState, 'Newsletter', $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "Form__label--checkbox",
    attrs: {
      "for": 'newsletter'
    }
  }, [_vm._v("\n            " + _vm._s(_vm.getStringTranslation('newsletter_signup')) + "\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "Form__info"
  }, [_vm._v("\n            " + _vm._s(_vm.options.newsletter_signup_text) + "\n          ")])])]) : _vm._e(), _vm._v(" "), (_vm.gdpr && _vm.gdpr.gdpr) ? _c('div', {
    staticClass: "Form__section Form__section--gdpr"
  }, [(_vm.getStringTranslation('gdpr')) ? _c('span', [_vm._v("\n          " + _vm._s(_vm.getStringTranslation('gdpr')) + " *\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "Form__field-wrapper Form__field-wrapper--checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formState['Datenschutz']),
      expression: "formState['Datenschutz']"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "Form__field--checkbox",
    attrs: {
      "type": "checkbox",
      "id": _vm.cleanLabel(_vm.gdprFieldName),
      "name": _vm.gdprFieldName
    },
    domProps: {
      "checked": Array.isArray(_vm.formState['Datenschutz']) ? _vm._i(_vm.formState['Datenschutz'], null) > -1 : (_vm.formState['Datenschutz'])
    },
    on: {
      "change": function($event) {
        var $$a = _vm.formState['Datenschutz'],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.formState, 'Datenschutz', $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.formState, 'Datenschutz', $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.formState, 'Datenschutz', $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "Form__label--checkbox",
    attrs: {
      "for": _vm.cleanLabel(_vm.gdprFieldName)
    }
  }, [_vm._v("\n            " + _vm._s(_vm.gdpr.gdpr_checkbox_label) + "\n          ")]), _vm._v(" "), (_vm.gdpr.gdpr) ? _c('span', {
    staticClass: "Form__info",
    domProps: {
      "innerHTML": _vm._s(_vm.gdpr.gdpr)
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.veeValidateErrors.has(_vm.gdprFieldName)),
      expression: "veeValidateErrors.has(gdprFieldName)"
    }],
    staticClass: "Form__error"
  }, [_vm._v("\n            " + _vm._s(_vm.veeValidateErrors.first(_vm.gdprFieldName)) + "\n          ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "Form__section"
  }, [_c('button', {
    staticClass: "Form__button",
    on: {
      "click": _vm.submitHandler
    }
  }, [_c('span', {
    staticClass: "Form__button-inner"
  }, [_vm._v(_vm._s(_vm.buttonText))])])])], 2)])], 1)
},staticRenderFns: []}

/***/ }),
/* 241 */
/*!************************************************!*\
  !*** ./client/components/ContentList/index.js ***!
  \************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_scss__ = __webpack_require__(/*! ./style.scss */ 242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Title__ = __webpack_require__(/*! components/Title */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_RichText__ = __webpack_require__(/*! components/RichText */ 7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(/*! vuex */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_getPathFromUrl__ = __webpack_require__(/*! util/getPathFromUrl */ 8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_verifyLeadingSlashLang__ = __webpack_require__(/*! util/verifyLeadingSlashLang */ 6);









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ContentList',
  props: ['componentData'],
  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['lang'])),
  render: function render(h) {
    var componentData = this.componentData,
        lang = this.lang;

    return h(
      'ul',
      { 'class': 'ContentList' },
      [componentData && componentData.length ? componentData.map(function (i) {
        return h(
          'li',
          { 'class': 'ContentList__item' },
          [h(
            __WEBPACK_IMPORTED_MODULE_1_components_Title__["a" /* default */],
            { 'class': 'ContentList__item-title', attrs: { id: i.section_title, level: 2 }
            },
            [i.section_title]
          ), h(
            'ul',
            { 'class': 'ContentList__sublist' },
            [i.list_items && i.list_items.length ? i.list_items.map(function (s) {
              return h(
                'li',
                { 'class': 'ContentList__sublist-item' },
                [renderSublistLink(h, s, lang), h(__WEBPACK_IMPORTED_MODULE_2_components_RichText__["a" /* default */], {
                  attrs: { content: s.content }
                })]
              );
            }) : null]
          )]
        );
      }) : null]
    );
  }
});

function renderSublistLink(h, s, lang) {
  if (s.link_type === 'external_link') {
    return h(
      'a',
      { 'class': 'ContentList__sublist-item-title ContentList__sublist-item-title--link', attrs: { href: s.external_link_url, target: '_blank', rel: 'noopener' }
      },
      [s.title]
    );
  } else if (s.link_type === 'internal_link') {
    return h(
      'router-link',
      { 'class': 'ContentList__sublist-item-title ContentList__sublist-item-title--link', attrs: { to: Object(__WEBPACK_IMPORTED_MODULE_5_util_verifyLeadingSlashLang__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4_util_getPathFromUrl__["a" /* default */])(s.internal_link), lang) }
      },
      [s.title]
    );
  } else if (s.link_type === 'file') {
    return h(
      'a',
      { 'class': 'ContentList__sublist-item-title ContentList__sublist-item-title--link', attrs: { href: s.file_link, target: '_blank', rel: 'noopener' }
      },
      [s.title]
    );
  } else {
    return h(
      __WEBPACK_IMPORTED_MODULE_1_components_Title__["a" /* default */],
      { 'class': 'ContentList__sublist-item-title', attrs: { id: s.title, level: 2 }
      },
      [s.title]
    );
  }
}

/***/ }),
/* 242 */
/*!**************************************************!*\
  !*** ./client/components/ContentList/style.scss ***!
  \**************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 243 */
/*!**************************************************!*\
  !*** ./client/components/DownloadsList/index.js ***!
  \**************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_scss__ = __webpack_require__(/*! ./style.scss */ 244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Title__ = __webpack_require__(/*! components/Title */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_LinkGroup__ = __webpack_require__(/*! components/LinkGroup */ 15);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DownloadsList',
  props: ['componentData'],
  computed: {
    downloadsListData: function downloadsListData() {
      return this.componentData.map(function (x) {
        x.download_links.map(function (y) {
          y['external_link'] = !y.is_internal_link;
          y['external_link_url'] = y.file_link ? y.file_link : null;
          y['internal_link'] = y.is_internal_link ? y.internal_link : null;
          y.title = y.title;
          return y;
        });
        return x;
      });
    }
  },
  render: function render(h) {
    var downloadsListData = this.downloadsListData;

    return h(
      'ul',
      { 'class': 'DownloadsList' },
      [downloadsListData && downloadsListData.length ? downloadsListData.map(function (i) {
        return h(
          'li',
          { 'class': 'DownloadsList__item' },
          [h(
            __WEBPACK_IMPORTED_MODULE_1_components_Title__["a" /* default */],
            { 'class': 'DownloadsList__item-title', attrs: { id: i.title, level: 2 }
            },
            [i.title]
          ), h(__WEBPACK_IMPORTED_MODULE_2_components_LinkGroup__["a" /* default */], { 'class': 'DownloadsList__links', attrs: { componentData: i.download_links }
          })]
        );
      }) : null]
    );
  }
});

/***/ }),
/* 244 */
/*!****************************************************!*\
  !*** ./client/components/DownloadsList/style.scss ***!
  \****************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 245 */
/*!**********************************************!*\
  !*** ./client/components/VideoGrid/index.js ***!
  \**********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props__ = __webpack_require__(/*! babel-helper-vue-jsx-merge-props */ 5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss__ = __webpack_require__(/*! ./style.scss */ 246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Title__ = __webpack_require__(/*! components/Title */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_RichText__ = __webpack_require__(/*! components/RichText */ 7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Modal__ = __webpack_require__(/*! components/Modal */ 247);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VideoGrid',
  props: ['componentData'],
  methods: {
    handleImageClick: function handleImageClick(e) {
      this.$store.dispatch('openModal', { id: e.target.id });
    }
  },
  render: function render(h) {
    var _this = this;

    var componentData = this.componentData,
        handleImageClick = this.handleImageClick;

    return h(
      'div',
      { 'class': 'VideoGrid' },
      [componentData.map(function (i, index) {
        return h(
          'div',
          { 'class': 'VideoGrid__item' },
          [h(
            'div',
            __WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props___default()([{ 'class': 'VideoGrid__image',
              attrs: { id: 'modal-' + index,
                role: 'button'
              },

              style: 'background-image: url(\'' + i.poster_image.sizes.friwi_med + '\')'
            }, {
              on: {
                'click': function click($event) {
                  for (var _len = arguments.length, attrs = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                    attrs[_key - 1] = arguments[_key];
                  }

                  handleImageClick.bind(_this).apply(undefined, [$event].concat(attrs));
                }
              }
            }]),
            [h(
              'div',
              { 'class': 'VideoGrid__playbutton' },
              [h('div', { 'class': 'VideoGrid__playbutton-inner' })]
            )]
          ), h('img', { 'class': 'VideoGrid__printImage', attrs: { src: i.poster_image.sizes.friwi_med }
          }), h(
            __WEBPACK_IMPORTED_MODULE_2_components_Title__["a" /* default */],
            { 'class': 'VideoGrid__title', attrs: { level: 3, id: i.title }
            },
            [i.title]
          ), h(__WEBPACK_IMPORTED_MODULE_3_components_RichText__["a" /* default */], { 'class': 'VideoGrid__text', attrs: { content: i.text }
          }), h(
            __WEBPACK_IMPORTED_MODULE_4_components_Modal__["a" /* default */],
            {
              attrs: { id: 'modal-' + index }
            },
            [h(
              'div',
              { 'class': 'Modal__embed-container' },
              [h('div', { 'class': 'Modal__embed', domProps: {
                  'innerHTML': i.oembed
                }
              })]
            )]
          )]
        );
      })]
    );
  }
});

// <div>{i.title}, {i.text}, {i.oembed}, {i.poster_image.sizes.friwi_med}</div>

/***/ }),
/* 246 */
/*!************************************************!*\
  !*** ./client/components/VideoGrid/style.scss ***!
  \************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 247 */
/*!******************************************!*\
  !*** ./client/components/Modal/index.js ***!
  \******************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props__ = __webpack_require__(/*! babel-helper-vue-jsx-merge-props */ 5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss__ = __webpack_require__(/*! ./style.scss */ 248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(/*! vuex */ 1);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Modal',
  props: {
    'id': {
      type: String,
      required: true
    }
  },
  mounted: function mounted() {
    var _this = this;

    document.addEventListener('keydown', function (e) {
      if (e.keyCode === 27) {
        _this.handleKeyDown(e);
      }
    });
  },

  methods: {
    handleModalClick: function handleModalClick(e, outside) {
      outside ? this.$store.dispatch('closeModal', { id: this.id }) : '';
    },
    handleButtonClick: function handleButtonClick() {
      this.$store.dispatch('closeModal', { id: this.id });
    },
    handleKeyDown: function handleKeyDown(e) {
      this.$store.dispatch('closeModal', { id: this.id });
    }
  },
  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["d" /* mapState */])(['ui']), {
    isOpen: function isOpen() {
      return this.ui.modalOpen === this.id;
    }
  }),
  render: function render(h) {
    var _this2 = this;

    var isOpen = this.isOpen;

    if (isOpen) {
      return h(
        'transition',
        {
          attrs: { name: 'Modal__transition' }
        },
        [h(
          'div',
          { 'class': 'Modal' },
          [h('div', __WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props___default()([{ 'class': 'Modal__backdrop' }, {
            on: {
              'click': function click($event) {
                for (var _len = arguments.length, attrs = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                  attrs[_key - 1] = arguments[_key];
                }

                (function (e) {
                  return _this2.handleModalClick(e, true);
                }).apply(undefined, [$event].concat(attrs));
              }
            }
          }])), h(
            'div',
            { 'class': 'Modal__wrapper' },
            [h(
              'div',
              __WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props___default()([{ 'class': 'Modal__container' }, {
                on: {
                  'click': function click($event) {
                    for (var _len2 = arguments.length, attrs = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
                      attrs[_key2 - 1] = arguments[_key2];
                    }

                    (function (e) {
                      return _this2.handleModalClick(e, false);
                    }).apply(undefined, [$event].concat(attrs));
                  }
                }
              }]),
              [this.$slots.default, h(
                'button',
                __WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props___default()([{ 'class': 'Modal__button' }, {
                  on: {
                    'click': function click($event) {
                      for (var _len3 = arguments.length, attrs = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
                        attrs[_key3 - 1] = arguments[_key3];
                      }

                      _this2.handleButtonClick.bind(_this2).apply(undefined, [$event].concat(attrs));
                    }
                  }
                }]),
                ['Schliessen']
              )]
            )]
          )]
        )]
      );
    }
  }
});

/***/ }),
/* 248 */
/*!********************************************!*\
  !*** ./client/components/Modal/style.scss ***!
  \********************************************/
/*! dynamic exports provided */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 249 */
/*!***************************************************!*\
  !*** ./client/components/ContactSection/index.js ***!
  \***************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_scss__ = __webpack_require__(/*! ./style.scss */ 250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Title__ = __webpack_require__(/*! components/Title */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_RichText__ = __webpack_require__(/*! components/RichText */ 7);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ContactSection',
  props: ['title', 'items'],
  render: function render(h) {
    var title = this.title,
        items = this.items;

    return h(
      'div',
      { 'class': 'ContactSection' },
      [h(
        __WEBPACK_IMPORTED_MODULE_1_components_Title__["a" /* default */],
        { 'class': 'ContactSection__title', attrs: { level: 2, id: title }
        },
        [title]
      ), h(
        'div',
        { 'class': 'ContactSection__items' },
        [items.map(function (i) {
          return h(
            'div',
            { 'class': 'ContactSection__item' },
            [h(__WEBPACK_IMPORTED_MODULE_2_components_RichText__["a" /* default */], {
              attrs: { content: i.content }
            })]
          );
        })]
      )]
    );
  }
});

/***/ }),
/* 250 */
/*!*****************************************************!*\
  !*** ./client/components/ContactSection/style.scss ***!
  \*****************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 251 */
/*!***************************************************!*\
  !*** ./client/components/GalleryWrapper/index.js ***!
  \***************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props__ = __webpack_require__(/*! babel-helper-vue-jsx-merge-props */ 5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss__ = __webpack_require__(/*! ./style.scss */ 252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_image_lightbox__ = __webpack_require__(/*! vue-image-lightbox */ 253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_image_lightbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_image_lightbox__);



__webpack_require__(/*! vue-image-lightbox/dist/vue-image-lightbox.min.css */ 254);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'GalleryWrapper',
  props: ['componentData'],
  computed: {
    images: function images() {
      return this.componentData.filter(function (x) {
        return x.image && x.image.sizes;
      }).map(function (x) {
        var y = {};
        y.thumb = x.image.sizes.friwi_med;
        y.src = x.image.url;
        return y;
      });
    }
  },
  methods: {
    handleThumbClick: function handleThumbClick(e, index) {
      // this.log('index: ', index)
      this.$refs.lightbox.showImage(index);
    }
  },
  render: function render(h) {
    var _this = this;

    var images = this.images;

    return h(
      'div',
      { 'class': 'GalleryWrapper' },
      [h(
        'ul',
        { 'class': 'GalleryWrapper__thumbs' },
        [images ? images.map(function (i, index) {
          return h(
            'li',
            __WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props___default()([{
              'class': 'GalleryWrapper__thumb'
            }, {
              on: {
                'click': function click($event) {
                  for (var _len = arguments.length, attrs = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                    attrs[_key - 1] = arguments[_key];
                  }

                  (function (e) {
                    return _this.handleThumbClick(e, index);
                  }).apply(undefined, [$event].concat(attrs));
                }
              }
            }]),
            [h('div', { 'class': 'GalleryWrapper__thumb-inner',
              style: 'background-image: url(\'' + i.thumb + '\')'
            })]
          );
        }) : null]
      ), h(__WEBPACK_IMPORTED_MODULE_2_vue_image_lightbox___default.a, {
        attrs: {
          media: images,
          showLightBox: false
        },
        ref: 'lightbox'
      })]
    );
  }
});

/***/ }),
/* 252 */
/*!*****************************************************!*\
  !*** ./client/components/GalleryWrapper/style.scss ***!
  \*****************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 253 */,
/* 254 */,
/* 255 */
/*!*******************************************!*\
  !*** ./client/components/Header/index.js ***!
  \*******************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss__ = __webpack_require__(/*! ./style.scss */ 256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Logo__ = __webpack_require__(/*! components/Logo */ 171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_MetaNav__ = __webpack_require__(/*! components/MetaNav */ 258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_MainNav__ = __webpack_require__(/*! components/MainNav */ 260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_MobileNav__ = __webpack_require__(/*! components/MobileNav */ 262);









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Header',
  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["d" /* mapState */])({
    open: function open(state) {
      return state.ui.menuOpen;
    },
    modalOpen: function modalOpen(state) {
      return state.ui.modalOpen;
    }
  }),
  render: function render(h) {
    return h(
      'header',
      { 'class': 'Header' + (this.modalOpen ? ' is-hidden' : '') },
      [h(
        'div',
        { 'class': 'Header__content Header__content--mobile' },
        [h(__WEBPACK_IMPORTED_MODULE_5_components_MobileNav__["a" /* default */])]
      ), h(
        'div',
        { 'class': 'Header__content Header__content--meta',
          attrs: { hidden: this.open ? 'hidden' : null
          }
        },
        [h(__WEBPACK_IMPORTED_MODULE_3_components_MetaNav__["a" /* default */], {
          attrs: { location: 'meta' }
        })]
      ), h(
        'div',
        { 'class': 'Header__content Header__content--main',
          attrs: { hidden: this.open ? 'hidden' : null
          }
        },
        [h(
          'div',
          { 'class': 'Header__logo' },
          [h(__WEBPACK_IMPORTED_MODULE_2_components_Logo__["a" /* default */])]
        ), h(
          'div',
          { 'class': 'Header__nav' },
          [h(__WEBPACK_IMPORTED_MODULE_4_components_MainNav__["a" /* default */])]
        )]
      )]
    );
  }
});

/***/ }),
/* 256 */
/*!*********************************************!*\
  !*** ./client/components/Header/style.scss ***!
  \*********************************************/
/*! dynamic exports provided */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 257 */
/*!*******************************************!*\
  !*** ./client/components/Logo/style.scss ***!
  \*******************************************/
/*! dynamic exports provided */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 258 */
/*!********************************************!*\
  !*** ./client/components/MetaNav/index.js ***!
  \********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_scss__ = __webpack_require__(/*! ./style.scss */ 259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(/*! vuex */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_verifyLeadingSlashLang__ = __webpack_require__(/*! util/verifyLeadingSlashLang */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util_getPathFromUrl__ = __webpack_require__(/*! util/getPathFromUrl */ 8);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MetaNav',
  props: ['location'],
  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getMenu', 'loaded', 'lang', 'otherLangLink', 'getStringTranslation', 'error']), {
    menu: function menu() {
      return this.getMenu(this.location);
    },
    otherLangLinkPath: function otherLangLinkPath() {
      return this.otherLangLink ? Object(__WEBPACK_IMPORTED_MODULE_3_util_getPathFromUrl__["a" /* default */])(this.otherLangLink) : '';
    }
  }),
  methods: {
    getTranslation: function getTranslation(translationTitle) {
      return this.getStringTranslation(translationTitle);
    },
    clearSearchQuery: function clearSearchQuery() {
      this.$store.dispatch('clearSearchQuery');
    }
  },
  render: function render(h) {
    var loaded = this.loaded,
        menu = this.menu,
        lang = this.lang,
        otherLangLinkPath = this.otherLangLinkPath,
        error = this.error;

    return h(
      'nav',
      { 'class': 'MetaNav' },
      [loaded ? h(
        'ul',
        { 'class': 'MetaNav__list' },
        [menu && menu.items ? menu.items.map(function (i) {
          return h(
            'li',
            { 'class': 'MetaNav__list-item' },
            [h(
              'router-link',
              {
                attrs: { to: Object(__WEBPACK_IMPORTED_MODULE_2_util_verifyLeadingSlashLang__["a" /* default */])(i.object_slug, lang) },
                'class': 'MetaNav__list-item-link' },
              [i.title]
            )]
          );
        }) : null, h(
          'li',
          { 'class': 'MetaNav__list-item MetaNav__list-item--icon' },
          [h('img', { 'class': 'MetaNav__searchIcon', attrs: { src: '/imgs/searchIcon-black.svg', alt: 'searchIcon' }
          }), h(
            'router-link',
            {
              nativeOn: {
                'click': this.clearSearchQuery
              },
              attrs: { to: lang === 'en' ? '/en/search' : '/suchen' },
              'class': 'MetaNav__list-item-link' },
            [this.getTranslation('search')]
          )]
        ), !error ? h(
          'li',
          { 'class': 'MetaNav__list-item' },
          [h(
            'router-link',
            {
              attrs: { to: this.lang === 'de' ? this.$route.fullPath : otherLangLinkPath },
              'class': 'MetaNav__list-item-link' },
            ['DE']
          )]
        ) : '', !error ? h(
          'li',
          { 'class': 'MetaNav__list-item' },
          [h(
            'router-link',
            {
              attrs: { to: this.lang === 'en' ? this.$route.fullPath : otherLangLinkPath },
              'class': 'MetaNav__list-item-link' },
            ['EN']
          )]
        ) : '']
      ) : 'Loading…']
    );
  }
});

/***/ }),
/* 259 */
/*!**********************************************!*\
  !*** ./client/components/MetaNav/style.scss ***!
  \**********************************************/
/*! dynamic exports provided */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 260 */
/*!********************************************!*\
  !*** ./client/components/MainNav/index.js ***!
  \********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_scss__ = __webpack_require__(/*! ./style.scss */ 261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(/*! vuex */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_verifyLeadingSlashLang__ = __webpack_require__(/*! util/verifyLeadingSlashLang */ 6);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MainNav',
  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getMenu', 'loaded', 'lang']), {
    menu: function menu() {
      return this.getMenu('main');
    }
  }),
  render: function render(h) {
    var loaded = this.loaded,
        menu = this.menu,
        lang = this.lang;

    return h(
      'nav',
      { 'class': 'MainNav' },
      [loaded ? h(
        'ul',
        { 'class': 'MainNav__list' },
        [menu && menu.items ? menu.items.map(function (i) {
          return h(
            'li',
            { 'class': 'MainNav__list-item' },
            [h(
              'router-link',
              {
                attrs: { to: Object(__WEBPACK_IMPORTED_MODULE_2_util_verifyLeadingSlashLang__["a" /* default */])(i.object_slug, lang) },
                'class': 'MainNav__list-item-link' },
              [i.title]
            ), i.children && i.children.length ? h(
              'ul',
              { 'class': 'MainNav__sublist' },
              [i.children.map(function (c) {
                return h(
                  'li',
                  { 'class': 'MainNav__sublist-item' },
                  [h(
                    'router-link',
                    {
                      attrs: { to: Object(__WEBPACK_IMPORTED_MODULE_2_util_verifyLeadingSlashLang__["a" /* default */])(i.object_slug + '/' + c.object_slug, lang) },
                      'class': 'MainNav__sublist-item-link' },
                    [c.title]
                  )]
                );
              })]
            ) : null]
          );
        }) : null]
      ) : 'Loading…']
    );
  }
});

/***/ }),
/* 261 */
/*!**********************************************!*\
  !*** ./client/components/MainNav/style.scss ***!
  \**********************************************/
/*! dynamic exports provided */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 262 */
/*!**********************************************!*\
  !*** ./client/components/MobileNav/index.js ***!
  \**********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props__ = __webpack_require__(/*! babel-helper-vue-jsx-merge-props */ 5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss__ = __webpack_require__(/*! ./style.scss */ 263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(/*! vuex */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Logo__ = __webpack_require__(/*! components/Logo */ 171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Burger__ = __webpack_require__(/*! components/Burger */ 264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_LinkGroup__ = __webpack_require__(/*! components/LinkGroup */ 15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Link__ = __webpack_require__(/*! components/Link */ 26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Accordion__ = __webpack_require__(/*! components/Accordion */ 25);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MobileNav',
  data: function data() {
    return {
      ESCAPE_KEY: 27
    };
  },
  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['getMenu', 'loaded', 'lang', 'menuOpen', 'otherLangLink', 'error']), {
    menu: function menu() {
      return this.getMenu('main');
    },
    menuMeta: function menuMeta() {
      return this.getMenu('meta');
    },
    menuMetaLinkGroup: function menuMetaLinkGroup() {
      // we have to transform this data to fit the LinkGroup component
      if (this.menuMeta.items) {
        return this.menuMeta.items.map(function (x) {
          return {
            title: x.title,
            'internal_link': x.url
          };
        });
      }
    }
  }),
  methods: {
    closeMenu: function closeMenu() {
      this.$store.dispatch('closeMenu');
    },
    handleKeyDown: function handleKeyDown(e) {
      switch (e.keyCode) {
        case this.ESCAPE_KEY:
          this.closeMenu();
          break;
        default:
          break;
      }
    }
  },
  beforeMount: function beforeMount() {
    document.addEventListener('keydown', this.handleKeyDown.bind(this));
  },
  mounted: function mounted() {
    this.show = true;
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeyDown.bind(this));
  },
  render: function render(h) {
    var loaded = this.loaded,
        menu = this.menu,
        menuOpen = this.menuOpen,
        closeMenu = this.closeMenu,
        menuMetaLinkGroup = this.menuMetaLinkGroup,
        lang = this.lang,
        otherLangLink = this.otherLangLink,
        error = this.error;

    return h(
      'div',
      { 'class': 'MobileNav' },
      [h(__WEBPACK_IMPORTED_MODULE_3_components_Logo__["a" /* default */], { 'class': 'MobileNav__logo', nativeOn: {
          'click': closeMenu
        }
      }), h(
        'router-link',
        {
          attrs: { to: lang === 'en' ? '/en/search' : '/suchen' },
          nativeOn: {
            'click': closeMenu
          }
        },
        [h('img', { 'class': 'MobileNav__searchIcon', attrs: { src: '/imgs/searchIcon.svg', alt: 'searchIcon' }
        })]
      ), h(__WEBPACK_IMPORTED_MODULE_4_components_Burger__["a" /* default */], { 'class': 'Menu__burger' }), menuOpen ? h(
        'div',
        { 'class': 'MobileNav__overlay' },
        [h(
          'nav',
          { 'class': 'MobileNav__nav' },
          [h(
            'div',
            { 'class': 'MobileNav__nav-content' },
            [loaded && menu && menu.items ? h(__WEBPACK_IMPORTED_MODULE_7_components_Accordion__["a" /* default */], {
              attrs: { isNavigation: true, modifiers: ['nav'], sections: menu.items }
            }) : 'Loading…']
          ), h(
            'div',
            __WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props___default()([{ 'class': 'MobileNav__meta' }, {
              on: {
                'click': function click($event) {
                  for (var _len = arguments.length, attrs = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                    attrs[_key - 1] = arguments[_key];
                  }

                  closeMenu.apply(undefined, [$event].concat(attrs));
                }
              }
            }]),
            [h(__WEBPACK_IMPORTED_MODULE_5_components_LinkGroup__["a" /* default */], { 'class': 'MobileNav__meta-linkgroup', attrs: { componentData: menuMetaLinkGroup }
            }), !error ? h(__WEBPACK_IMPORTED_MODULE_6_components_Link__["a" /* default */], {
              attrs: { title: this.lang === 'en' ? 'Deutsch' : 'English', internalLinkAbsolute: otherLangLink },
              'class': 'MobileNav__button' }) : null]
          )]
        )]
      ) : null]
    );
  }
});

/***/ }),
/* 263 */
/*!************************************************!*\
  !*** ./client/components/MobileNav/style.scss ***!
  \************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 264 */
/*!*******************************************!*\
  !*** ./client/components/Burger/index.js ***!
  \*******************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props__ = __webpack_require__(/*! babel-helper-vue-jsx-merge-props */ 5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(/*! vuex */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_scss__ = __webpack_require__(/*! ./style.scss */ 265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_scss__);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Burger',
  methods: {
    toggleMenu: function toggleMenu() {
      this.$store.dispatch('toggleMenu');
    }
  },
  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['menuOpen'])),
  render: function render(h) {
    var menuOpen = this.menuOpen,
        toggleMenu = this.toggleMenu;

    return h(
      'button',
      __WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props___default()([{
        attrs: { type: 'button', 'aria-label': 'Open Menu' },
        'class': 'Burger' + (menuOpen ? ' is-open' : '') }, {
        on: {
          'click': function click($event) {
            for (var _len = arguments.length, attrs = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
              attrs[_key - 1] = arguments[_key];
            }

            toggleMenu.bind().apply(undefined, [$event].concat(attrs));
          }
        }
      }]),
      [h('div', { 'class': 'Burger__burger' })]
    );
  }
});

/***/ }),
/* 265 */
/*!*********************************************!*\
  !*** ./client/components/Burger/style.scss ***!
  \*********************************************/
/*! dynamic exports provided */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 266 */
/*!*******************************************!*\
  !*** ./client/components/Footer/index.js ***!
  \*******************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_scss__ = __webpack_require__(/*! ./style.scss */ 267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(/*! vuex */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Title__ = __webpack_require__(/*! components/Title */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util_verifyLeadingSlashLang__ = __webpack_require__(/*! util/verifyLeadingSlashLang */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_getPathFromUrl__ = __webpack_require__(/*! util/getPathFromUrl */ 8);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Footer',
  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */])({
    open: function open(state) {
      return state.ui.menuOpen;
    },
    options: function options(state) {
      return state.data.data.options;
    }
  }), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getMenu', 'loaded', 'lang', 'otherLangLink', 'getStringTranslation', 'error']), {
    sitemapMenu: function sitemapMenu() {
      return this.getMenu('footer_sitemap');
    },
    metaMenu: function metaMenu() {
      return this.getMenu('footer_meta');
    },
    otherLangLinkPath: function otherLangLinkPath() {
      return this.otherLangLink ? Object(__WEBPACK_IMPORTED_MODULE_4_util_getPathFromUrl__["a" /* default */])(this.otherLangLink) : '';
    }
  }),
  methods: {
    getTranslation: function getTranslation(translationTitle) {
      return this.getStringTranslation(translationTitle);
    }
  },
  render: function render(h) {
    var sitemapMenu = this.sitemapMenu,
        metaMenu = this.metaMenu,
        open = this.open,
        options = this.options,
        loaded = this.loaded,
        lang = this.lang,
        otherLangLinkPath = this.otherLangLinkPath,
        error = this.error;

    return loaded ? h(
      'footer',
      { 'class': 'Footer',
        attrs: { hidden: open ? 'hidden' : null
        }
      },
      [h(
        'div',
        { 'class': 'Footer__content' },
        [h(
          'nav',
          { 'class': 'Footer__nav Footer__nav--sitemap' },
          [h(
            __WEBPACK_IMPORTED_MODULE_2_components_Title__["a" /* default */],
            { 'class': 'Footer__title', attrs: { level: 3 }
            },
            [this.getTranslation('sitemap')]
          ), h(
            'ul',
            { 'class': 'Footer__nav-list Footer__nav-list--sitemap' },
            [sitemapMenu && sitemapMenu.items ? sitemapMenu.items.map(function (i) {
              return h(
                'li',
                { 'class': 'Footer__nav-list-item' },
                [h(
                  'router-link',
                  {
                    attrs: { to: Object(__WEBPACK_IMPORTED_MODULE_3_util_verifyLeadingSlashLang__["a" /* default */])(i.object_slug, lang) },
                    'class': 'Footer__nav-list-item-link' },
                  [i.title]
                ), i.children && i.children.length ? h(
                  'ul',
                  { 'class': 'Footer__nav-sublist' },
                  [i.children.map(function (c) {
                    return h(
                      'li',
                      { 'class': 'Footer__nav-sublist-item' },
                      [h(
                        'router-link',
                        {
                          attrs: { to: Object(__WEBPACK_IMPORTED_MODULE_3_util_verifyLeadingSlashLang__["a" /* default */])(i.object_slug + '/' + c.object_slug, lang) },
                          'class': 'Footer__nav-sublist-item-link' },
                        [c.title]
                      )]
                    );
                  })]
                ) : null]
              );
            }) : null]
          )]
        ), h(
          'div',
          { 'class': 'Footer__contact' },
          [h(
            __WEBPACK_IMPORTED_MODULE_2_components_Title__["a" /* default */],
            { 'class': 'Footer__title', attrs: { level: 3 }
            },
            [options.contact_section_title]
          ), h(
            'div',
            { 'class': 'Footer__contact-items' },
            [options.contact_items.map(function (i) {
              return h(
                'div',
                { 'class': 'Footer__contact-item RichText' },
                [h('h4', [i.title]), h(
                  'ul',
                  { 'class': 'Footer__contact-item-list' },
                  [h('li', [h(
                    'a',
                    {
                      attrs: { href: '' + i.address_link, target: 'blank' }
                    },
                    [i.address_text]
                  )]), h('li', [h(
                    'a',
                    {
                      attrs: { href: 'mailto:' + i.email }
                    },
                    [i.email]
                  )]), h('li', [h(
                    'a',
                    {
                      attrs: { href: 'tel:' + i.phone_link }
                    },
                    ['T ', i.phone_number]
                  )])]
                )]
              );
            })]
          ), h(
            'div',
            { 'class': 'Footer__social' },
            [options.social_media_links.map(function (i) {
              return h(
                'a',
                { 'class': 'Footer__social-icon-link', attrs: { href: i.link, target: '_blank', rel: 'noopener' }
                },
                [h('img', { 'class': 'Footer__social-icon', attrs: { src: '/imgs/' + i.type + '.svg', alt: 'Social Media Icon' }
                })]
              );
            })]
          )]
        )]
      ), h(
        'div',
        { 'class': 'Footer__content' },
        [h(
          'div',
          { 'class': 'Footer__copyright' },
          [options.copyright_text + ' ' + new Date().getFullYear()]
        ), h(
          'nav',
          { 'class': 'Footer__nav Footer__nav--meta' },
          [h(
            'ul',
            { 'class': 'Footer__nav-list Footer__nav-list--meta' },
            [metaMenu && metaMenu.items ? metaMenu.items.map(function (i) {
              return h(
                'li',
                { 'class': 'Footer__nav-list-item Footer__nav-list-item--meta' },
                [h(
                  'router-link',
                  {
                    attrs: { to: Object(__WEBPACK_IMPORTED_MODULE_3_util_verifyLeadingSlashLang__["a" /* default */])(i.object_slug, lang) },
                    'class': 'Footer__nav-list-item-link Footer__nav-list-item-link--meta' },
                  [i.title]
                )]
              );
            }) : null, !error ? h(
              'li',
              { 'class': 'Footer__nav-list-item Footer__nav-list-item--meta' },
              [h(
                'router-link',
                {
                  attrs: { to: this.lang === 'de' ? this.$route.fullPath : otherLangLinkPath },
                  'class': 'Footer__nav-list-item-link Footer__nav-list-item-link--meta Footer__nav-list-item--lang-switcher' },
                ['DE']
              ), h(
                'router-link',
                {
                  attrs: { to: this.lang === 'en' ? this.$route.fullPath : otherLangLinkPath },
                  'class': 'Footer__nav-list-item-link Footer__nav-list-item-link--meta Footer__nav-list-item--lang-switcher' },
                ['EN']
              )]
            ) : null]
          )]
        )]
      )]
    ) : null;
  }
});

/***/ }),
/* 267 */
/*!*********************************************!*\
  !*** ./client/components/Footer/style.scss ***!
  \*********************************************/
/*! dynamic exports provided */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 268 */
/*!***********************************************!*\
  !*** ./client/components/HomeTeaser/index.js ***!
  \***********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_scss__ = __webpack_require__(/*! ./style.scss */ 269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_scss__);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HomeTeaser',
  props: ['show'],
  render: function render(h) {
    return this.show ? h(
      'aside',
      { 'class': 'HomeTeaser' },
      [h(
        'router-link',
        {
          attrs: {
            to: '/weiterbildung'
          },
          'class': 'HomeTeaser__wrapper'
        },
        [h(
          'p',
          { 'class': 'HomeTeaser__title' },
          ['frischer wind Seminare']
        )]
      )]
    ) : null;
  }
});

/***/ }),
/* 269 */
/*!*************************************************!*\
  !*** ./client/components/HomeTeaser/style.scss ***!
  \*************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 270 */,
/* 271 */,
/* 272 */
/*!********************************!*\
  !*** ./client/router/index.js ***!
  \********************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(/*! vue-router */ 273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_meta__ = __webpack_require__(/*! vue-meta */ 274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_meta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_meta__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Home__ = __webpack_require__(/*! ../views/Home */ 275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Wildcard__ = __webpack_require__(/*! ../views/Wildcard */ 277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Search__ = __webpack_require__(/*! ../views/Search */ 278);






/*! scaffold:import:route */

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_meta___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  linkActiveClass: 'is-active',
  linkExactActiveClass: 'is-active-exact',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },

  routes: [{
    path: '/',
    name: 'Home',
    alias: '/home',
    component: __WEBPACK_IMPORTED_MODULE_3__views_Home__["a" /* default */]
  }, {
    path: '/en',
    name: 'HomeEnglish',
    alias: '/en/home',
    component: __WEBPACK_IMPORTED_MODULE_3__views_Home__["a" /* default */]
  },
  /*! scaffold:insert:route */
  {
    path: '/suchen',
    alias: '/en/search',
    name: 'Search',
    component: __WEBPACK_IMPORTED_MODULE_5__views_Search__["a" /* default */]
  }, {
    path: '*',
    alias: '/en/*',
    name: 'Wildcard',
    component: __WEBPACK_IMPORTED_MODULE_4__views_Wildcard__["a" /* default */]
  }]
}));

/***/ }),
/* 273 */,
/* 274 */,
/* 275 */
/*!************************************!*\
  !*** ./client/views/Home/index.js ***!
  \************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(/*! ../../common */ 10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_views_Error__ = __webpack_require__(/*! views/Error */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Title__ = __webpack_require__(/*! components/Title */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_FlexContent__ = __webpack_require__(/*! components/FlexContent */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_HeroImage__ = __webpack_require__(/*! components/HeroImage */ 172);








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HomeView',
  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['loading', 'getPageBySlug', 'options']), {
    page: function page() {
      return this.getPageBySlug('home');
    },
    pageTitle: function pageTitle() {
      return this.page.page_title_override ? this.page.page_title_override : this.page.title.rendered;
    }
  }),
  metaInfo: function metaInfo() {
    var page = this.page;
    return page ? Object(__WEBPACK_IMPORTED_MODULE_1__common__["a" /* generateMetaInfo */])(this.options, this.page, { isHome: true }) : {};
  },
  mounted: function mounted() {
    this.setCurrentPage(this.page);
  },
  created: function created() {
    this.setCurrentPage(this.page);
  },

  watch: {
    '$route': function $route() {
      this.setCurrentPage(this.page);
    },
    loading: function loading() {
      this.setCurrentPage(this.page);
    }
  },
  methods: {
    setCurrentPage: function setCurrentPage(page) {
      this.$store.dispatch('setCurrentPage', page);
    },
    renderError: function renderError() {
      var h = this.$createElement;

      // this.log('error')
      return h(__WEBPACK_IMPORTED_MODULE_2_views_Error__["a" /* default */]);
    },
    renderPage: function renderPage() {
      var h = this.$createElement;

      // this.log(this.page)
      return h(
        'div',
        { 'class': 'page' },
        [this.page.hero_image ? h(__WEBPACK_IMPORTED_MODULE_5_components_HeroImage__["a" /* default */], {
          attrs: { imageUrl: this.page.hero_image.sizes.friwi_huge }
        }) : null, this.pageTitle ? h(
          __WEBPACK_IMPORTED_MODULE_3_components_Title__["a" /* default */],
          {
            attrs: { level: 1, id: this.pageTitle }
          },
          [this.pageTitle]
        ) : null, this.page.c_flex_content && this.page.c_flex_content.length ? h(__WEBPACK_IMPORTED_MODULE_4_components_FlexContent__["a" /* default */], {
          attrs: { componentData: this.page.c_flex_content }
        }) : null]
      );
    }
  },
  // beforeRouteEnter (to, from, next) {
  //   // console.log(to)
  //   next()
  // },
  // beforeRouteUpdate (to, from, next) {
  //   // console.log(to)
  //   next()
  // },
  render: function render(h) {
    var loading = this.loading,
        page = this.page;
    // this.log('page')

    return loading ? 'Loading…' : page ? this.renderPage() : this.renderError();
  }
});

/***/ }),
/* 276 */
/*!************************************************!*\
  !*** ./client/components/HeroImage/style.scss ***!
  \************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 277 */
/*!****************************************!*\
  !*** ./client/views/Wildcard/index.js ***!
  \****************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(/*! ../../common */ 10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_views_Error__ = __webpack_require__(/*! views/Error */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Breadcrumbs__ = __webpack_require__(/*! components/Breadcrumbs */ 23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Title__ = __webpack_require__(/*! components/Title */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_FlexContent__ = __webpack_require__(/*! components/FlexContent */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_HeroImage__ = __webpack_require__(/*! components/HeroImage */ 172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Form_Form__ = __webpack_require__(/*! components/Form/Form */ 27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Form_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_Form_Form__);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'WildcardView',
  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['loading', 'getPageBySlug', 'options', 'protected', 'pageAuthenticated']), {
    page: function page() {
      return this.getPageBySlug(this.$route.path);
    },
    pageTitle: function pageTitle() {
      return this.page.page_title_override ? this.page.page_title_override : this.page.title.rendered;
    },
    pageTitleWithLineBreaks: function pageTitleWithLineBreaks() {
      if (this.page.has_custom_line_breaks) {
        return this.page.custom_line_breaks_repeater.map(function (x) {
          return x.line;
        }).join('&shy;');
      } else {
        return false;
      }
    }
  }),
  metaInfo: function metaInfo() {
    var page = this.page;
    return page ? Object(__WEBPACK_IMPORTED_MODULE_1__common__["a" /* generateMetaInfo */])(this.options, this.page) : {};
  },
  mounted: function mounted() {
    this.setCurrentPage(this.page);
  },

  watch: {
    '$route': function $route() {
      this.setCurrentPage(this.page);
    },
    loading: function loading() {
      this.setCurrentPage(this.page);
    }
  },
  methods: {
    setCurrentPage: function setCurrentPage(page) {
      this.$store.dispatch('setCurrentPage', page);
    },
    renderError: function renderError() {
      var h = this.$createElement;

      // this.log('error occured')
      this.$store.dispatch('error', { error: { status: 404 } });
      return h(__WEBPACK_IMPORTED_MODULE_2_views_Error__["a" /* default */]);
    },
    renderPage: function renderPage() {
      var h = this.$createElement;

      // this.log(this.page)
      return h(
        'div',
        { 'class': 'page' },
        [this.page.hero_image ? h(__WEBPACK_IMPORTED_MODULE_6_components_HeroImage__["a" /* default */], {
          attrs: { imageUrl: this.page.hero_image.sizes.friwi_huge }
        }) : null, h(__WEBPACK_IMPORTED_MODULE_3_components_Breadcrumbs__["a" /* default */], {
          attrs: { page: this.page }
        }), this.pageTitleWithLineBreaks ? h(__WEBPACK_IMPORTED_MODULE_4_components_Title__["a" /* default */], {
          attrs: { level: 1, id: this.pageTitle, richText: this.pageTitleWithLineBreaks, modifiers: ['no-hyphens'] }
        }) : h(
          __WEBPACK_IMPORTED_MODULE_4_components_Title__["a" /* default */],
          {
            attrs: { level: 1, id: this.pageTitle }
          },
          [this.pageTitle]
        ), this.protected && !this.pageAuthenticated ? h(__WEBPACK_IMPORTED_MODULE_7_components_Form_Form___default.a, {
          attrs: { formEndpoint: '', buttonText: 'Login', isLogin: true, formFields: [{ label: 'Passwort', required: true, type: 'password' }] }
        }) : this.page.c_flex_content && this.page.c_flex_content.length ? h(__WEBPACK_IMPORTED_MODULE_5_components_FlexContent__["a" /* default */], {
          attrs: { componentData: this.page.c_flex_content }
        }) : null]
      );
    }
  },
  // beforeRouteEnter (to, from, next) {
  //   // console.log(to)
  //   next()
  // },
  // beforeRouteUpdate (to, from, next) {
  //   // console.log(to)
  //   next()
  // },
  render: function render(h) {
    var loading = this.loading,
        page = this.page;
    // this.log('page: ', page)

    return loading ? 'Loading…' : page ? this.renderPage() : this.renderError();
  }
});

/***/ }),
/* 278 */
/*!**************************************!*\
  !*** ./client/views/Search/index.js ***!
  \**************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(/*! ../../common */ 10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Search__ = __webpack_require__(/*! ../../components/Search */ 279);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SearchView',
  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['loading', 'getPageBySlug', 'options', 'pages']), {
    page: function page() {
      return this.getPageBySlug('suchen') ? this.getPageBySlug('suchen') : this.getPageBySlug('search');
    },
    pageTitle: function pageTitle() {
      return this.page.page_title_override ? this.page.page_title_override : this.page.title.rendered;
    }
  }),
  mounted: function mounted() {
    this.setCurrentPage(this.page);
  },

  watch: {
    '$route': function $route() {
      this.setCurrentPage(this.page);
    },
    loading: function loading() {
      this.setCurrentPage(this.page);
    }
  },
  methods: {
    setCurrentPage: function setCurrentPage(page) {
      this.$store.dispatch('setCurrentPage', page);
    }
  },
  metaInfo: function metaInfo() {
    var page = this.page;
    return page ? Object(__WEBPACK_IMPORTED_MODULE_1__common__["a" /* generateMetaInfo */])(this.options, this.page) : {};
  },
  render: function render(h) {
    var loading = this.loading,
        pages = this.pages;

    return !loading ? h(
      'div',
      { 'class': 'page' },
      [h(__WEBPACK_IMPORTED_MODULE_2__components_Search__["a" /* default */], {
        attrs: { list: pages }
      })]
    ) : null;
  }
});

/***/ }),
/* 279 */
/*!*******************************************!*\
  !*** ./client/components/Search/index.js ***!
  \*******************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props__ = __webpack_require__(/*! babel-helper-vue-jsx-merge-props */ 5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss__ = __webpack_require__(/*! ./style.scss */ 280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_debounce__ = __webpack_require__(/*! lodash.debounce */ 281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fuse_js__ = __webpack_require__(/*! fuse.js */ 282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fuse_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_fuse_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(/*! vuex */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_verifyLeadingSlashLang__ = __webpack_require__(/*! util/verifyLeadingSlashLang */ 6);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Search',
  props: ['list'],
  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['getParentsById', 'getStringTranslation', 'lang']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapState */])({
    searchQuery: function searchQuery(state) {
      return state.ui.searchQuery;
    }
  }), {
    fuse: function fuse() {
      var options = {
        shouldSort: true,
        tokenize: true,
        matchAllTokens: true,
        findAllMatches: true,
        includeScore: true,
        includeMatches: true,
        threshold: 0.1,
        location: 0,
        distance: 1000,
        maxPatternLength: 32,
        minMatchCharLength: 3,
        keys: [{
          name: 'title',
          weight: 0.4
        }, {
          name: 'titleOverride',
          weight: 0.4
        }, {
          name: 'content',
          weight: 0.2
        }]
      };
      var fuse = new __WEBPACK_IMPORTED_MODULE_3_fuse_js___default.a(this.pagesFlattened, options);
      // this.log(this.pagesFlattened)
      return fuse;
    },
    pagesFlattened: function pagesFlattened() {
      return this.list.map(function (p) {
        var content = (p.c_flex_content || []).map(function (c) {
          var string = '';
          if (c.rich_text) string += c.rich_text + ' ';

          if (c.acf_fc_layout === 'downloads_list') {
            string += c.downloads_section.reduce(function (acc, i) {
              return acc + ' ' + i.title + ' ' + i.download_links.reduce(function (acc, i) {
                return acc + i.title + ' ' + i.file_link + ' ' || '';
              }, '') || '';
            }, '') + ' ';
          }

          if (c.acf_fc_layout === 'content_list') {
            string += c.list_sections.reduce(function (acc, i) {
              return acc + ' ' + i.section_title + i.list_items.reduce(function (acc, i) {
                return acc + i.content + ' ' + i.title + ' ' || '';
              }, '') || '';
            }, '');
          }

          return string.replace(/<\/?[^>]+(>|$)/g, ''); // strips html tags
        });
        return {
          title: p.title.rendered,
          titleOverride: p.page_title_override,
          link: p.link,
          id: p.id,
          uri: p.uri,
          content: content.filter(String).join(' ')
        };
      });
    }
  }),
  methods: {
    getTranslation: function getTranslation(translationTitle) {
      return this.getStringTranslation(translationTitle);
    },
    search: function search(event) {
      this.hasSearched = true;
      var searchQery = event.target ? event.target.value : event;
      var result = this.fuse.search(searchQery);
      if (searchQery.length === 0) {
        result = [];
      }
      this.fuseList = result;
      // this.log(result)
      this.searchValue = searchQery;
      this.$store.dispatch('saveSearchQuery', searchQery);
    }
  },
  data: function data() {
    return {
      searchValue: '',
      fuseList: [],
      score: 0.6,
      hasSearched: false
    };
  },
  mounted: function mounted() {
    this.searchQuery ? this.search(this.searchQuery) : null;
  },
  render: function render(h) {
    var _this = this;

    var lang = this.lang;

    return h(
      'div',
      { 'class': 'Search' },
      [h(
        'div',
        { 'class': 'Search__inputContainer' },
        [h('input', __WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props___default()([{ 'class': 'Search__inputSearch', domProps: {
            'value': this.searchValue
          },
          attrs: { tabIndex: '0', placeholder: this.getTranslation('search') }
        }, {
          on: {
            'input': function input($event) {
              for (var _len = arguments.length, attrs = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                attrs[_key - 1] = arguments[_key];
              }

              __WEBPACK_IMPORTED_MODULE_2_lodash_debounce___default()(_this.search, 250).apply(undefined, [$event].concat(attrs));
            }
          }
        }])), h('img', { 'class': 'Search__inputIcon', attrs: { src: '/imgs/searchIcon.svg', alt: 'searchIcon' }
        })]
      ), h(
        'ul',
        { 'class': 'Search__list' },
        [h(
          'h3',
          { 'class': 'Search__resultText' },
          [this.fuseList.length && this.fuseList.find(function (i) {
            return i.score <= _this.score;
          }) ? this.getTranslation('searchresults') + (' «' + this.searchValue + '»') : this.searchValue && this.hasSearched ? this.getTranslation('nosearchresults') + (' «' + this.searchValue + '»') : null]
        ), this.fuseList.map(function (i, index) {
          if (i.score <= _this.score) {
            return h(
              'li',
              { 'class': 'Search__listItem' },
              [h(
                'router-link',
                {
                  attrs: { to: Object(__WEBPACK_IMPORTED_MODULE_5_util_verifyLeadingSlashLang__["a" /* default */])(i.item.uri, lang) },
                  'class': 'Search__listTitle' },
                [i.item.title]
              ), h(
                'p',
                { 'class': 'Search__listTeaser' },
                [(i.item.content ? i.item.content.substring(0, 125) : '') + (i.item.content && i.item.content.length > 125 ? '...' : '')]
              ), h(
                'router-link',
                {
                  attrs: { to: Object(__WEBPACK_IMPORTED_MODULE_5_util_verifyLeadingSlashLang__["a" /* default */])(i.item.uri, lang) },
                  'class': 'Search__listLink' },
                [_this.getParentsById(i.item.id).map(function (i) {
                  return h(
                    'span',
                    { 'class': 'Search__listLinkItem' },
                    [i.title.rendered]
                  );
                })]
              )]
            );
          }
        })]
      )]
    );
  }
});

// <a class='Search__listLink' href={item.item.link} target='_blank'>{item.item.link}</a>

/***/ }),
/* 280 */
/*!*********************************************!*\
  !*** ./client/components/Search/style.scss ***!
  \*********************************************/
/*! dynamic exports provided */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 281 */,
/* 282 */,
/* 283 */
/*!*******************************!*\
  !*** ./client/store/index.js ***!
  \*******************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(/*! vuex */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_store_ui__ = __webpack_require__(/*! store/ui */ 284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_store_error__ = __webpack_require__(/*! store/error */ 286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_store_data__ = __webpack_require__(/*! store/data */ 287);






/*! scaffold:import:module */

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var modules = {
  /*! scaffold:insert:module */
  ui: __WEBPACK_IMPORTED_MODULE_2_store_ui__["a" /* default */],
  error: __WEBPACK_IMPORTED_MODULE_3_store_error__["a" /* default */],
  data: __WEBPACK_IMPORTED_MODULE_4_store_data__["a" /* default */]
};

var getters = {};

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: modules,
  getters: getters
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 284 */
/*!****************************!*\
  !*** ./client/store/ui.js ***!
  \****************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var noScroll = __webpack_require__(/*! no-scroll */ 285);

var state = {
  menuOpen: false,
  modalOpen: false,
  searchQuery: ''
};

var actions = {
  toggleMenu: function toggleMenu(_ref) {
    var commit = _ref.commit,
        state = _ref.state;

    commit('TOGGLE_MENU');
  },
  closeMenu: function closeMenu(_ref2) {
    var commit = _ref2.commit,
        state = _ref2.state;

    commit('CLOSE_MENU');
  },
  openModal: function openModal(_ref3, payload) {
    var commit = _ref3.commit,
        state = _ref3.state;
    var id = payload.id;

    if (id && id !== state.modalOpen || id && !state.modalOpen) {
      commit('OPEN_MODAL', id);
    }
  },
  closeModal: function closeModal(_ref4) {
    var commit = _ref4.commit,
        state = _ref4.state;

    if (state.modalOpen !== false) {
      commit('CLOSE_MODAL');
    }
  },
  saveSearchQuery: function saveSearchQuery(_ref5, query) {
    var commit = _ref5.commit,
        state = _ref5.state;

    commit('SAVE_SEARCH_QUERY', query);
  },
  clearSearchQuery: function clearSearchQuery(_ref6) {
    var commit = _ref6.commit,
        state = _ref6.state;

    commit('CLEAR_SERCH_QUERY');
  }
};

var mutations = {
  TOGGLE_MENU: function TOGGLE_MENU(state) {
    state.menuOpen = !state.menuOpen;
    // noScroll causes a weird layout bug on iOS Safari ¯\_(ツ)_/¯
    // state.menuOpen ? noScroll.on() : noScroll.off()
  },
  CLOSE_MENU: function CLOSE_MENU(state) {
    state.menuOpen = false;
    // noScroll.off()
  },
  OPEN_MODAL: function OPEN_MODAL(state, open) {
    state.modalOpen = open;
    noScroll.on();
  },
  CLOSE_MODAL: function CLOSE_MODAL(state) {
    state.modalOpen = false;
    noScroll.off();
  },
  SAVE_SEARCH_QUERY: function SAVE_SEARCH_QUERY(state, query) {
    state.searchQuery = query;
  },
  CLEAR_SERCH_QUERY: function CLEAR_SERCH_QUERY(state) {
    state.searchQuery = '';
  }
};

var getters = {
  menuOpen: function menuOpen(state) {
    return state.menuOpen;
  }
};

var module = {
  state: state,
  actions: actions,
  mutations: mutations,
  getters: getters
};

/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 285 */,
/* 286 */
/*!*******************************!*\
  !*** ./client/store/error.js ***!
  \*******************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  status: 0,
  statusMessage: ''
};

var actions = {
  error: function error(_ref) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch,
        state = _ref.state;
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var error = payload.error;
    // console.log(error)

    commit('ERROR_SET', error);
  },
  resetError: function resetError(_ref2) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch,
        state = _ref2.state;

    if (state.status !== 0) {
      commit('ERROR_RESET');
    }
  }
};

var mutations = {
  ERROR_SET: function ERROR_SET(state) {
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var status = payload.status,
        statusMessage = payload.statusMessage;

    state.status = status || 0;
    state.statusMessage = statusMessage || '';
  },
  ERROR_RESET: function ERROR_RESET(state) {
    state.status = 0;
    state.statusMessage = '';
  }
};

var getters = {
  error: function error(state) {
    return state.status !== 0;
  }
};

var module = {
  state: state,
  actions: actions,
  mutations: mutations,
  getters: getters
};

/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 287 */
/*!******************************!*\
  !*** ./client/store/data.js ***!
  \******************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_api_getData__ = __webpack_require__(/*! api/getData */ 288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_util_cleanSlug__ = __webpack_require__(/*! util/cleanSlug */ 289);



var state = {
  data: {},
  currentLanguage: 'de',
  currentPage: {},
  loading: false,
  loaded: false,
  error: false,
  authenticatedPages: []
};

var actions = {
  loadData: function loadData(_ref, lang) {
    var commit = _ref.commit,
        state = _ref.state;

    lang ? commit('LANGUAGE_CHANGE', lang) : null;
    commit('DATA_LOAD');
    if (!state.loaded || state.data.lang !== state.currentLanguage) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_api_getData__["a" /* default */])(state.currentLanguage).then(function (response) {
        commit('DATA_SAVE', response);
      }).catch(function (error) {
        console.log(error);
        commit('DATA_CANCEL_LOAD');
        commit('DATA_ERROR', error);
        /**
         * You could also emit a global error here that then triggers the
         * <Error /> view in the <App /> component. For example if you use a store
         * to load a single post and the api returns a 404. Then it could make sense
         * to dispatch it like so:
         *
         *   // ...
         *   .catch((error) => {
         *     commit('DATA_CANCEL_LOAD')
         *     commit('DATA_ERROR', error)
         *     dispatch('error', { error })
         *   })
         *
         **/
      });
    } else {
      return true;
    }
  },
  changeLanguage: function changeLanguage(_ref2, lang) {
    var dispatch = _ref2.dispatch,
        commit = _ref2.commit,
        state = _ref2.state;

    if (state.currentLanguage !== lang) {
      commit('LANGUAGE_CHANGE', lang);
    }
  },
  setCurrentPage: function setCurrentPage(_ref3, page) {
    var dispatch = _ref3.dispatch,
        commit = _ref3.commit;

    commit('SAVE_CURRENT_PAGE', page);
  },
  authenticatePage: function authenticatePage(_ref4) {
    var dispatch = _ref4.dispatch,
        commit = _ref4.commit;

    commit('PAGE_AUTHENTICATE');
  }
};

var mutations = {
  DATA_LOAD: function DATA_LOAD(state, data) {
    state.loading = true;
  },
  DATA_CANCEL_LOAD: function DATA_CANCEL_LOAD(state) {
    state.loading = false;
  },
  DATA_ERROR: function DATA_ERROR(state, error) {
    state.error = error;
    state.loading = false;
  },
  DATA_SAVE: function DATA_SAVE(state, data) {
    state.data = data;
    state.loaded = true;
    state.loading = false;
    state.error = false;
  },
  LANGUAGE_CHANGE: function LANGUAGE_CHANGE(state, lang) {
    state.currentLanguage = lang;
  },
  SAVE_CURRENT_PAGE: function SAVE_CURRENT_PAGE(state, page) {
    state.currentPage = page;
    // console.log('current page', state.currentPage.polylang)
  },
  PAGE_AUTHENTICATE: function PAGE_AUTHENTICATE(state) {
    if (state.authenticatedPages.indexOf(state.currentPage.id) === -1) state.authenticatedPages.push(state.currentPage.id);
  }
};

var getters = {
  loaded: function loaded(state) {
    return state.loaded;
  },
  loading: function loading(state) {
    return state.loading;
  },
  lang: function lang(state) {
    return state.currentLanguage;
  },
  options: function options(state) {
    return state.data && state.data.options ? state.data.options : false;
  },
  pages: function pages(state) {
    return state.data && state.data.pages ? state.data.pages : false;
  },
  protected: function _protected(state) {
    return state.data && state.currentPage ? state.currentPage.content.protected : false;
  },
  pageAuthenticated: function pageAuthenticated(state) {
    return state.data && state.currentPage ? state.authenticatedPages.indexOf(state.currentPage.id) !== -1 : false;
  },
  currentPage: function currentPage(state) {
    return state.data && state.currentPage ? state.currentPage : false;
  },
  otherLangLink: function otherLangLink(state) {
    var otherLang = state.currentLanguage === 'de' ? 'en' : 'de';
    // const urlRegex = /^https?:\/\/(www\.)*(.*)(\.[a-z]*)/
    if (state.currentPage && state.currentPage.polylang) {
      if (state.currentPage.polylang.translations && state.currentPage.polylang.translations[otherLang]) {
        // const otherLangLink = state.currentPage.polylang.translations[otherLang].permalink.replace(urlRegex, '')
        return state.currentPage.polylang.translations[otherLang].permalink;
      } else {
        return otherLang;
      }
    }
  },
  /**
   * getMenu getter is a function so it must called like this this.getMenu('main')
   */
  getMenu: function getMenu(state, getters) {
    return function (location) {
      if (!state.loaded) return false;
      if (!state.data.menus || !state.data.menus[location]) return false;
      return state.data.menus[location].menu;
    };
  },
  getPageBySlug: function getPageBySlug(state, getters) {
    return function (slug) {
      if (!state.loaded) return false;
      if (!state.data.pages) return false;
      // console.log('getPageBySlug: ' + cleanSlug(slug))
      return state.data.pages.find(function (p) {
        return p.uri === Object(__WEBPACK_IMPORTED_MODULE_1_util_cleanSlug__["a" /* default */])(slug);
      });
    };
  },
  getPageById: function getPageById(state, getters) {
    return function (id) {
      if (!state.loaded) return false;
      if (!state.data.pages) return false;
      return state.data.pages.find(function (p) {
        return p.id === id;
      });
    };
  },
  getParentsById: function getParentsById(state, getters) {
    return function (id) {
      if (!state.loaded) return false;
      if (!state.data.pages) return false;

      var parentsArray = [];
      var currentPage = state.data.pages.find(function (p) {
        return p.id === id;
      });
      parentsArray.unshift(currentPage);

      while (currentPage.parent) {
        var parentPage = state.data.pages.find(function (p) {
          return p.id === currentPage.parent;
        });
        parentsArray.unshift(parentPage);
        currentPage = parentPage;
      }

      return parentsArray;
    };
  },
  getStringTranslation: function getStringTranslation(state, getters) {
    return function (title) {
      if (!state.loaded) return false;
      var translation = state.data.options.translation.find(function (t) {
        return t.title === title;
      });
      return translation ? translation.text : '';
    };
  }
};

var module = {
  state: state,
  actions: actions,
  mutations: mutations,
  getters: getters
};

/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 288 */
/*!*******************************!*\
  !*** ./client/api/getData.js ***!
  \*******************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getData;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(/*! axios */ 16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


function getData(lang) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/data/basic.' + lang + '.json', {
    transformResponse: [].concat(__WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.transformResponse
    // transformDataHoweverYouWant
    )
  }).then(function (res) {
    return res.data;
  });
}

/***/ }),
/* 289 */
/*!**********************************!*\
  !*** ./client/util/cleanSlug.js ***!
  \**********************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cleanSlug;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_util_removeTrailingSlash__ = __webpack_require__(/*! util/removeTrailingSlash */ 290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_util_removeLeadingSlash__ = __webpack_require__(/*! util/removeLeadingSlash */ 291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_removeLeadingLang__ = __webpack_require__(/*! util/removeLeadingLang */ 292);




function cleanSlug(string) {
  return Object(__WEBPACK_IMPORTED_MODULE_2_util_removeLeadingLang__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1_util_removeLeadingSlash__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0_util_removeTrailingSlash__["a" /* default */])(string)));
}

/***/ }),
/* 290 */
/*!********************************************!*\
  !*** ./client/util/removeTrailingSlash.js ***!
  \********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = removeTrailingSlash;
function removeTrailingSlash(string) {
  return string.endsWith('/') ? string.slice(0, -1) : string;
}

/***/ }),
/* 291 */
/*!*******************************************!*\
  !*** ./client/util/removeLeadingSlash.js ***!
  \*******************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = removeLeadingSlash;
function removeLeadingSlash(string) {
  return string.startsWith('/') ? string.substr(1) : string;
}

/***/ }),
/* 292 */
/*!******************************************!*\
  !*** ./client/util/removeLeadingLang.js ***!
  \******************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = removeLeadingLang;
function removeLeadingLang(string) {
  return string.startsWith('en/') ? string.substr(3) : string;
}

/***/ })
],[173]);


// WEBPACK FOOTER //
// client.de5af3f9.js